webpackJsonp([54],{

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = getIsLoggedInO365;
/* harmony export (immutable) */ __webpack_exports__["e"] = getUserInfo;
/* unused harmony export getUserEmail */
/* harmony export (immutable) */ __webpack_exports__["a"] = getForgotPassword;
/* harmony export (immutable) */ __webpack_exports__["d"] = getResetPassword;
function getIsLoggedIn(state) {
    return !!state.auth.bsrsToken;
}

function getIsLoggedInO365(state) {
    return !!state.auth.token.access_token;
}

function getUserInfo(state) {
    return state.auth.user;
}

function getUserEmail(state) {
    return state.auth.user.email;
}
function getForgotPassword(state) {
    return state.forgotPassword;
}
function getResetPassword(state) {
    return state.resetPassword;
}

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return O365_REGISTER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return O365_REGISTER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return O365_REGISTER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return O365_LOAD_EVENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return O365_LOAD_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return O365_LOAD_EVENTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return O365_LOAD_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return O365_LOAD_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return O365_LOAD_EVENT_FAILURE; });
/* unused harmony export O365_LOAD_EDIT_EVENT_REQUEST */
/* unused harmony export O365_LOAD_EDIT_EVENT_SUCCESS */
/* unused harmony export O365_LOAD_EDIT_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return O365_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return O365_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return O365_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return O365_CREATE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return O365_CREATE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return O365_CREATE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return O365_UPDATE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return O365_UPDATE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return O365_UPDATE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return O365_DELETE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return O365_DELETE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return O365_DELETE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BSRS_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BSRS_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSRS_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return O365_ACCEPT_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return O365_ACCEPT_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return O365_ACCEPT_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return O365_TENTATIVE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return O365_TENTATIVE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return O365_TENTATIVE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return O365_DECLINE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return O365_DECLINE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return O365_DECLINE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_LOAD_ORDERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_LOAD_ORDERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_LOAD_ORDERS_FAILURE; });
/* unused harmony export CORE_LOAD_ORDER_DETAIL_REQUEST */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_SUCCESS */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_FAILURE */
/* unused harmony export CORE_CHANGE_ORDER_AMOUNT */
/* unused harmony export CORE_UPSERT_ORDERS_REQUEST */
/* unused harmony export CORE_UPSERT_ORDERS_SUCCESS */
/* unused harmony export CORE_UPSERT_ORDERS_FAILURE */
/* unused harmony export CORE_LOAD_CHEKIN_REQUEST */
/* unused harmony export CORE_LOAD_CHEKIN_SUCCESS */
/* unused harmony export CORE_LOAD_CHEKIN_FAILURE */
/* unused harmony export CORE_CREATE_CHECKIN_REQUEST */
/* unused harmony export CORE_CREATE_CHECKIN_SUCCESS */
/* unused harmony export CORE_CREATE_CHECKIN_FAILURE */
/* unused harmony export O365_CHECKOUT_EVENT_REQUEST */
/* unused harmony export O365_CHECKOUT_EVENT_SUCCESS */
/* unused harmony export O365_CHECKOUT_EVENT_FAILURE */
/* unused harmony export O365_LOAD_PEOPLE_REQUEST */
/* unused harmony export O365_LOAD_PEOPLE_SUCCESS */
/* unused harmony export O365_LOAD_PEOPLE_FAILURE */
/* unused harmony export O365_LOAD_LOCATION_REQUEST */
/* unused harmony export O365_LOAD_LOCATION_SUCCESS */
/* unused harmony export O365_LOAD_LOCATION_FAILURE */
/* unused harmony export O365_SEARCH_SLOT_REQUEST */
/* unused harmony export O365_SEARCH_SLOT_SUCCESS */
/* unused harmony export O365_SEARCH_SLOT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_INTEGRATION_O365_ADD_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_INTEGRATION_O365_ADMIN_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_INTEGRATION_O365_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_INTEGRATION_O365_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_INTEGRATION_O365_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return CORE_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return CORE_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return CORE_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_LOAD_TERM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_LOAD_TERM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_LOAD_TERM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_LOAD_CONTACT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_LOAD_CONTACT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_LOAD_CONTACT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_LOAD_FAQ_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_LOAD_FAQ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_LOAD_FAQ_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_LOAD_INTEGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_LOAD_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_LOAD_INTEGRATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return CORE_USER_INTEGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return CORE_USER_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return CORE_USER_INTEGRATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return CORE_REMOVE_INTEGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return CORE_REMOVE_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return CORE_REMOVE_INTEGRATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return CORE_SEARCH_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return CORE_SEARCH_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return CORE_SEARCH_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_LOAD_O365URL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_LOAD_O365URL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_LOAD_O365URL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return O365_LOAD_EVENTLIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return O365_LOAD_EVENTLIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return O365_LOAD_EVENTLIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return O365_LOAD_EVENTDETAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return O365_LOAD_EVENTDETAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return O365_LOAD_EVENTDETAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return O365_SUGGEST_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return O365_SUGGEST_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return O365_SUGGEST_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return O365_SUGGESTTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return O365_SUGGESTTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return O365_SUGGESTTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_LOAD_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return O365_USER_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return O365_USER_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return O365_USER_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_GET_ROOM_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_GET_ROOM_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_GET_ROOM_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_GET_ROOM_STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_GET_ROOM_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_GET_ROOM_STATUS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return SERVICE_SEARCH_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return SERVICE_SEARCH_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return SERVICE_SEARCH_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CHECKIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CHECKIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CHECKIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return O365_CHECKOUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return O365_CHECKOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return O365_CHECKOUT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return SERVICE_DELETE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return SERVICE_DELETE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return SERVICE_DELETE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return SERVICE_ACCEPT_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return SERVICE_ACCEPT_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return SERVICE_ACCEPT_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return SERVICE_DECILNE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return SERVICE_DECILNE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return SERVICE_DECILNE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return SERVICE_TENTATIVELY_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return SERVICE_TENTATIVELY_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return SERVICE_TENTATIVELY_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_LOAD_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_LOAD_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_LOAD_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_CREATE_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_CREATE_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_CREATE_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_LOAD_FOODACTIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_LOAD_FOODACTIVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_LOAD_FOODACTIVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_LOAD_FOODPAST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_LOAD_FOODPAST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_LOAD_FOODPAST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_LOAD_EVENTSERVICEFBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_LOAD_EVENTSERVICEFBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_LOAD_EVENTSERVICEFBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_LOAD_EVENTINFOSERVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_LOAD_EVENTINFOSERVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_LOAD_EVENTINFOSERVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return CORE_SENDFOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return CORE_SENDFOOD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return CORE_SENDFOOD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_DONEFOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_DONEFOOD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_DONEFOOD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_LOAD_EVENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_LOAD_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_LOAD_EVENTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return CORE_UPDATE_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return CORE_UPDATE_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return CORE_UPDATE_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_LOAD_ORDERS_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_LOAD_ORDERS_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_LOAD_ORDERS_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return O365_LOAD_EVENTLIST_BETWEEN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return O365_LOAD_EVENTLIST_BETWEEN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return O365_LOAD_EVENTLIST_BETWEEN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_LOAD_SETTING_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_LOAD_SETTING_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_LOAD_SETTING_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return O365_LOAD_EVENTLISTFULL_BETWEEN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return CORE_LOAD_TIMEZOZE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return CORE_LOAD_TIMEZOZE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_LOAD_TIMEZOZE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return CORE_UPDATE_TIMEZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return CORE_UPDATE_TIMEZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return CORE_UPDATE_TIMEZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_LOAD_FOODNEXT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_LOAD_FOODNEXT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_LOAD_FOODNEXT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_CANCELEVENTFOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_CANCELEVENTFOOD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_CANCELEVENTFOOD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_LOAD_AMENITYNEXT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_LOAD_AMENITYNEXT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_LOAD_AMENITYNEXT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_DONEAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_DONEAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_DONEAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CANCELEVENTAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CANCELEVENTAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CANCELEVENTAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return CORE_SENDAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return CORE_SENDAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return CORE_SENDAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_LOAD_AMENITYPAST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_LOAD_AMENITYPAST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_LOAD_AMENITYPAST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_LOAD_EVENTSERVICEAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_LOAD_EVENTSERVICEAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_LOAD_AMENITYACTIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_LOAD_AMENITYACTIVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_LOAD_AMENITYACTIVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_LOAD_SUGGEST_INFORMATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_LOAD_SUGGEST_INFORMATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_LOAD_SUGGEST_INFORMATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_LOAD_EVENTHOME_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_LOAD_EVENTHOME_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_LOAD_EVENTHOME_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_GET_FAVORITEROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_GET_FAVORITEROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_GET_FAVORITEROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return CORE_UPDATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return CORE_UPDATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return CORE_UPDATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_INTEGRATION_EXCHANGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_INTEGRATION_EXCHANGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_INTEGRATION_EXCHANGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_GETURL_GOOGLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_GETURL_GOOGLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_GETURL_GOOGLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_INTEGRATION_GOOGLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_INTEGRATION_GOOGLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_INTEGRATION_GOOGLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_GET_FAVORITESEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_GET_FAVORITESEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_GET_FAVORITESEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_LOAD_ALL_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_LOAD_ALL_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_LOAD_ALL_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_LOAD_ALL_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_LOAD_ALL_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_LOAD_ALL_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_LOAD_ALL_ZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_LOAD_ALL_ZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_LOAD_ALL_ZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return CORE_SUGGEST_SEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return CORE_SUGGEST_SEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return CORE_SUGGEST_SEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CREATE_EVENT_SEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CREATE_EVENT_SEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CREATE_EVENT_SEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_DELETE_EVENT_SEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_DELETE_EVENT_SEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_DELETE_EVENT_SEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_GET_EVENT_SEATGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_GET_EVENT_SEATGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_GET_EVENT_SEATGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_GET_MYEVENT_SEATBYDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_GET_MYEVENT_SEATBYDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_GET_MYEVENT_SEATBYDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return O365_SUGGEST_ROOM_MEETING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return O365_SUGGEST_ROOM_MEETING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return O365_SUGGEST_ROOM_MEETING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_ADD_FAVORITEROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_ADD_FAVORITEROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_ADD_FAVORITEROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return CORE_REMOVE_FAVORITEROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return CORE_REMOVE_FAVORITEROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return CORE_REMOVE_FAVORITEROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_LOAD_ALLFACILITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_LOAD_ALLFACILITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_LOAD_ALLFACILITIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_LOAD_ALLFOODANDBEV_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_LOAD_ALLFOODANDBEV_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_LOAD_ALLFOODANDBEV_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CREATE_AMENITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CREATE_AMENITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CREATE_AMENITIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_LOAD_ORDERAMENITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_LOAD_ORDERAMENITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_LOAD_ORDERAMENITIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CREATE_FOODANDBEV_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_CREATE_FOODANDBEV_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CREATE_FOODANDBEV_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_LOAD_ORDERFOODANDBEV_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_LOAD_ORDERFOODANDBEV_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_LOAD_ORDERFOODANDBEV_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_LOAD_ORDERINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_LOAD_ORDERINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_LOAD_ORDERINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_DELETE_ORDERAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_DELETE_ORDERAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_DELETE_ORDERAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_DELETE_ORDERFOODANDBEV_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_DELETE_ORDERFOODANDBEV_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_DELETE_ORDERFOODANDBEV_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return CORE_UPDATE_ORDERFOODANDBEV_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return CORE_UPDATE_ORDERFOODANDBEV_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return CORE_UPDATE_ORDERFACILITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return CORE_UPDATE_ORDERFOODANDBEV_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return CORE_UPDATE_ORDERFACILITIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return CORE_UPDATE_ORDERFACILITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_FORGOT_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_FORGOT_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_FORGOT_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CONFIRM_RESET_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CONFIRM_RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CONFIRM_RESET_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_GET_CAN_BOOKING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_GET_CAN_BOOKING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_GET_CAN_BOOKING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_GET_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_GET_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_GET_ROOMDISABLE_FAILURE; });
var LOGOUT = 'LOGOUT';
var SET_ERROR = 'SET_ERROR';

var O365_REGISTER_REQUEST = 'O365_REGISTER_REQUEST';
var O365_REGISTER_SUCCESS = 'O365_REGISTER_SUCCESS';
var O365_REGISTER_FAILURE = 'O365_REGISTER_FAILURE';

var O365_LOAD_EVENTS_REQUEST = 'O365_LOAD_EVENTS_REQUEST';
var O365_LOAD_EVENTS_SUCCESS = 'O365_LOAD_EVENTS_SUCCESS';
var O365_LOAD_EVENTS_FAILURE = 'O365_LOAD_EVENTS_FAILURE';

var O365_LOAD_EVENT_REQUEST = 'O365_LOAD_EVENT_REQUEST';
var O365_LOAD_EVENT_SUCCESS = 'O365_LOAD_EVENT_SUCCESS';
var O365_LOAD_EVENT_FAILURE = 'O365_LOAD_EVENT_FAILURE';

var O365_LOAD_EDIT_EVENT_REQUEST = 'O365_LOAD_EDIT_EVENT_REQUEST';
var O365_LOAD_EDIT_EVENT_SUCCESS = 'O365_LOAD_EDIT_EVENT_SUCCESS';
var O365_LOAD_EDIT_EVENT_FAILURE = 'O365_LOAD_EDIT_EVENT_FAILURE';

var O365_LOAD_USER_INFO_REQUEST = 'O365_LOAD_USER_INFO_REQUEST';
var O365_LOAD_USER_INFO_SUCCESS = 'O365_LOAD_USER_INFO_SUCCESS';
var O365_LOAD_USER_INFO_FAILURE = 'O365_LOAD_USER_INFO_FAILURE';

var O365_CREATE_EVENT_REQUEST = 'O365_CREATE_EVENT_REQUEST';
var O365_CREATE_EVENT_SUCCESS = 'O365_CREATE_EVENT_SUCCESS';
var O365_CREATE_EVENT_FAILURE = 'O365_CREATE_EVENT_FAILURE';

var O365_UPDATE_EVENT_REQUEST = 'O365_UPDATE_EVENT_REQUEST';
var O365_UPDATE_EVENT_SUCCESS = 'O365_UPDATE_EVENT_SUCCESS';
var O365_UPDATE_EVENT_FAILURE = 'O365_UPDATE_EVENT_FAILURE';

var O365_DELETE_EVENT_REQUEST = 'O365_DELETE_EVENT_REQUEST';
var O365_DELETE_EVENT_SUCCESS = 'O365_DELETE_EVENT_SUCCESS';
var O365_DELETE_EVENT_FAILURE = 'O365_DELETE_EVENT_FAILURE';

var BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST';
var BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS';
var BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE';

var O365_ACCEPT_EVENT_REQUEST = 'O365_ACCEPT_EVENT_REQUEST';
var O365_ACCEPT_EVENT_SUCCESS = 'O365_ACCEPT_EVENT_SUCCESS';
var O365_ACCEPT_EVENT_FAILURE = 'O365_ACCEPT_EVENT_FAILURE';

var O365_TENTATIVE_EVENT_REQUEST = 'O365_TENTATIVE_EVENT_REQUEST';
var O365_TENTATIVE_EVENT_SUCCESS = 'O365_TENTATIVE_EVENT_SUCCESS';
var O365_TENTATIVE_EVENT_FAILURE = 'O365_TENTATIVE_EVENT_FAILURE';

var O365_DECLINE_EVENT_REQUEST = 'O365_DECLINE_EVENT_REQUEST';
var O365_DECLINE_EVENT_SUCCESS = 'O365_DECLINE_EVENT_SUCCESS';
var O365_DECLINE_EVENT_FAILURE = 'O365_DECLINE_EVENT_FAILURE';

var CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST';
var CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS';
var CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE';

var CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST';
var CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS';
var CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE';

var CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT';

var CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST';
var CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS';
var CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE';

var CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST';
var CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS';
var CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE';

var CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST';
var CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS';
var CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE';

var O365_CHECKOUT_EVENT_REQUEST = 'O365_CHECKOUT_EVENT_REQUEST';
var O365_CHECKOUT_EVENT_SUCCESS = 'O365_CHECKOUT_EVENT_SUCCESS';
var O365_CHECKOUT_EVENT_FAILURE = 'O365_CHECKOUT_EVENT_FAILURE';

var O365_LOAD_PEOPLE_REQUEST = 'O365_LOAD_PEOPLE_REQUEST';
var O365_LOAD_PEOPLE_SUCCESS = 'O365_LOAD_PEOPLE_SUCCESS';
var O365_LOAD_PEOPLE_FAILURE = 'O365_LOAD_PEOPLE_FAILURE';

var O365_LOAD_LOCATION_REQUEST = 'O365_LOAD_LOCATION_REQUEST';
var O365_LOAD_LOCATION_SUCCESS = 'O365_LOAD_LOCATION_SUCCESS';
var O365_LOAD_LOCATION_FAILURE = 'O365_LOAD_LOCATION_FAILURE';

var O365_SEARCH_SLOT_REQUEST = 'O365_SEARCH_SLOT_REQUEST';
var O365_SEARCH_SLOT_SUCCESS = 'O365_SEARCH_SLOT_SUCCESS';
var O365_SEARCH_SLOT_FAILURE = 'O365_SEARCH_SLOT_FAILURE';

var CORE_INTEGRATION_O365_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_ADD_CLIENT_ID';
var CORE_INTEGRATION_O365_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_ADMIN_CONSENT';

var CORE_INTEGRATION_O365_REQUEST = 'CORE_INTEGRATION_O365_REQUEST';
var CORE_INTEGRATION_O365_SUCCESS = 'CORE_INTEGRATION_O365_SUCCESS';
var CORE_INTEGRATION_O365_FAILURE = 'CORE_INTEGRATION_O365_FAILURE';

var CORE_LOAD_USER_INFO_REQUEST = 'CORE_LOAD_USER_INFO_REQUEST';
var CORE_LOAD_USER_INFO_SUCCESS = 'CORE_LOAD_USER_INFO_SUCCESS';
var CORE_LOAD_USER_INFO_FAILURE = 'CORE_LOAD_USER_INFO_FAILURE';

var CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST';
var CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS';
var CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE';

var CORE_LOAD_TERM_REQUEST = 'CORE_LOAD_TERM_REQUEST';
var CORE_LOAD_TERM_SUCCESS = 'CORE_LOAD_TERM_SUCCESS';
var CORE_LOAD_TERM_FAILURE = 'CORE_LOAD_TERM_FAILURE';

var CORE_LOAD_CONTACT_REQUEST = 'CORE_LOAD_CONTACT_REQUEST';
var CORE_LOAD_CONTACT_SUCCESS = 'CORE_LOAD_CONTACT_SUCCESS';
var CORE_LOAD_CONTACT_FAILURE = 'CORE_LOAD_CONTACT_FAILURE';

var CORE_LOAD_FAQ_REQUEST = 'CORE_LOAD_FAQ_REQUEST';
var CORE_LOAD_FAQ_SUCCESS = 'CORE_LOAD_FAQ_SUCCESS';
var CORE_LOAD_FAQ_FAILURE = 'CORE_LOAD_FAQ_FAILURE';

var CORE_LOAD_INTEGRATION_REQUEST = 'CORE_LOAD_INTEGRATION_REQUEST';
var CORE_LOAD_INTEGRATION_SUCCESS = 'CORE_LOAD_INTEGRATION_SUCCESS';
var CORE_LOAD_INTEGRATION_FAILURE = 'CORE_LOAD_INTEGRATION_FAILURE';

var CORE_USER_INTEGRATION_REQUEST = 'CORE_USER_INTEGRATION_REQUEST';
var CORE_USER_INTEGRATION_SUCCESS = 'CORE_USER_INTEGRATION_SUCCESS';
var CORE_USER_INTEGRATION_FAILURE = 'CORE_USER_INTEGRATION_FAILURE';

var CORE_REMOVE_INTEGRATION_REQUEST = 'CORE_REMOVE_INTEGRATION_REQUEST';
var CORE_REMOVE_INTEGRATION_SUCCESS = 'CORE_REMOVE_INTEGRATION_SUCCESS';
var CORE_REMOVE_INTEGRATION_FAILURE = 'CORE_REMOVE_INTEGRATION_FAILURE';

var CORE_SEARCH_ROOM_REQUEST = 'CORE_SEARCH_ROOM_REQUEST';
var CORE_SEARCH_ROOM_SUCCESS = 'CORE_SEARCH_ROOM_SUCCESS';
var CORE_SEARCH_ROOM_FAILURE = 'CORE_SEARCH_ROOM_FAILURE';

var CORE_LOAD_O365URL_REQUEST = 'CORE_LOAD_O365URL_REQUEST';
var CORE_LOAD_O365URL_SUCCESS = 'CORE_LOAD_O365URL_SUCCESS';
var CORE_LOAD_O365URL_FAILURE = 'CORE_LOAD_O365URL_FAILURE';

var O365_LOAD_EVENTLIST_REQUEST = 'O365_LOAD_EVENTLIST_REQUEST';
var O365_LOAD_EVENTLIST_SUCCESS = 'O365_LOAD_EVENTLIST_SUCCESS';
var O365_LOAD_EVENTLIST_FAILURE = 'O365_LOAD_EVENTLIST_FAILURE';

var O365_LOAD_EVENTDETAIL_REQUEST = 'O365_LOAD_EVENTDETAIL_REQUEST';
var O365_LOAD_EVENTDETAIL_SUCCESS = 'O365_LOAD_EVENTDETAIL_SUCCESS';
var O365_LOAD_EVENTDETAIL_FAILURE = 'O365_LOAD_EVENTDETAIL_FAILURE';

var O365_SUGGEST_ROOM_REQUEST = 'O365_SUGGEST_ROOM_REQUEST';
var O365_SUGGEST_ROOM_SUCCESS = 'O365_SUGGEST_ROOM_SUCCESS';
var O365_SUGGEST_ROOM_FAILURE = 'O365_SUGGEST_ROOM_FAILURE';

var O365_SUGGESTTION_REQUEST = 'O365_SUGGESTTION_REQUEST';
var O365_SUGGESTTION_SUCCESS = 'O365_SUGGESTTION_SUCCESS';
var O365_SUGGESTTION_FAILURE = 'O365_SUGGESTTION_FAILURE';

var CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST';
var CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS';
var CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE';

var O365_USER_LIST_REQUEST = 'O365_USER_LIST_REQUEST';
var O365_USER_LIST_SUCCESS = 'O365_USER_LIST_SUCCESS';
var O365_USER_LIST_FAILURE = 'O365_USER_LIST_FAILURE';

var CORE_GET_ROOM_INFO_REQUEST = 'CORE_GET_ROOM_INFO_REQUEST';
var CORE_GET_ROOM_INFO_SUCCESS = 'CORE_GET_ROOM_INFO_SUCCESS';
var CORE_GET_ROOM_INFO_FAILURE = 'CORE_GET_ROOM_INFO_FAILURE';

var CORE_GET_ROOM_STATUS_REQUEST = 'CORE_GET_ROOM_STATUS_REQUEST';
var CORE_GET_ROOM_STATUS_SUCCESS = 'CORE_GET_ROOM_STATUS_SUCCESS';
var CORE_GET_ROOM_STATUS_FAILURE = 'CORE_GET_ROOM_STATUS_FAILURE';

var SERVICE_SEARCH_USERS_REQUEST = 'SERVICE_SEARCH_USERS_REQUEST';
var SERVICE_SEARCH_USERS_SUCCESS = 'SERVICE_SEARCH_USERS_SUCCESS';
var SERVICE_SEARCH_USERS_FAILURE = 'SERVICE_SEARCH_USERS_FAILURE';

var CORE_CHECKIN_REQUEST = 'CORE_CHECKIN_REQUEST';
var CORE_CHECKIN_SUCCESS = 'CORE_CHECKIN_SUCCESS';
var CORE_CHECKIN_FAILURE = 'CORE_CHECKIN_FAILURE';

var O365_CHECKOUT_REQUEST = 'O365_CHECKOUT_REQUEST';
var O365_CHECKOUT_SUCCESS = 'O365_CHECKOUT_SUCCESS';
var O365_CHECKOUT_FAILURE = 'O365_CHECKOUT_FAILURE';

var SERVICE_DELETE_EVENT_REQUEST = 'SERVICE_DELETE_EVENT_REQUEST';
var SERVICE_DELETE_EVENT_SUCCESS = 'SERVICE_DELETE_EVENT_SUCCESS';
var SERVICE_DELETE_EVENT_FAILURE = 'SERVICE_DELETE_EVENT_FAILURE';

var SERVICE_ACCEPT_EVENT_REQUEST = 'SERVICE_ACCEPT_EVENT_REQUEST';
var SERVICE_ACCEPT_EVENT_SUCCESS = 'SERVICE_ACCEPT_EVENT_SUCCESS';
var SERVICE_ACCEPT_EVENT_FAILURE = 'SERVICE_ACCEPT_EVENT_FAILURE';

var SERVICE_DECILNE_EVENT_REQUEST = 'SERVICE_DECILNE_EVENT_REQUEST';
var SERVICE_DECILNE_EVENT_SUCCESS = 'SERVICE_DECILNE_EVENT_SUCCESS';
var SERVICE_DECILNE_EVENT_FAILURE = 'SERVICE_DECILNE_EVENT_FAILURE';

var SERVICE_TENTATIVELY_EVENT_REQUEST = 'SERVICE_TENTATIVELY_EVENT_REQUEST';
var SERVICE_TENTATIVELY_EVENT_SUCCESS = 'SERVICE_TENTATIVELY_EVENT_SUCCESS';
var SERVICE_TENTATIVELY_EVENT_FAILURE = 'SERVICE_TENTATIVELY_EVENT_FAILURE';

var CORE_LOAD_FBS_REQUEST = 'CORE_LOAD_FBS_REQUEST';
var CORE_LOAD_FBS_SUCCESS = 'CORE_LOAD_FBS_SUCCESS';
var CORE_LOAD_FBS_FAILURE = 'CORE_LOAD_FBS_FAILURE';

var CORE_CREATE_ORDER_REQUEST = 'CORE_CREATE_ORDER_REQUEST';
var CORE_CREATE_ORDER_SUCCESS = 'CORE_CREATE_ORDER_SUCCESS';
var CORE_CREATE_ORDER_FAILURE = 'CORE_CREATE_ORDER_FAILURE';

var CORE_LOAD_FOODACTIVE_REQUEST = 'CORE_LOAD_FOODACTIVE_REQUEST';
var CORE_LOAD_FOODACTIVE_SUCCESS = 'CORE_LOAD_FOODACTIVE_SUCCESS';
var CORE_LOAD_FOODACTIVE_FAILURE = 'CORE_LOAD_FOODACTIVE_FAILURE';

var CORE_LOAD_FOODPAST_REQUEST = 'CORE_LOAD_FOODPAST_REQUEST';
var CORE_LOAD_FOODPAST_SUCCESS = 'CORE_LOAD_FOODPAST_SUCCESS';
var CORE_LOAD_FOODPAST_FAILURE = 'CORE_LOAD_FOODPAST_FAILURE';

var CORE_LOAD_EVENTSERVICEFBS_REQUEST = 'CORE_LOAD_EVENTSERVICEFBS_REQUEST';
var CORE_LOAD_EVENTSERVICEFBS_SUCCESS = 'CORE_LOAD_EVENTSERVICEFBS_SUCCESS';
var CORE_LOAD_EVENTSERVICEFBS_FAILURE = 'CORE_LOAD_EVENTSERVICEFBS_FAILURE';

var CORE_LOAD_EVENTINFOSERVICE_REQUEST = 'CORE_LOAD_EVENTINFOSERVICE_REQUEST';
var CORE_LOAD_EVENTINFOSERVICE_SUCCESS = 'CORE_LOAD_EVENTINFOSERVICE_SUCCESS';
var CORE_LOAD_EVENTINFOSERVICE_FAILURE = 'CORE_LOAD_EVENTINFOSERVICE_FAILURE';

var CORE_SENDFOOD_REQUEST = 'CORE_SENDFOOD_REQUEST';
var CORE_SENDFOOD_SUCCESS = 'CORE_SENDFOOD_SUCCESS';
var CORE_SENDFOOD_FAILURE = 'CORE_SENDFOOD_FAILURE';

var CORE_DONEFOOD_REQUEST = 'CORE_DONEFOOD_REQUEST';
var CORE_DONEFOOD_SUCCESS = 'CORE_DONEFOOD_SUCCESS';
var CORE_DONEFOOD_FAILURE = 'CORE_DONEFOOD_FAILURE';

var CORE_LOAD_EVENTS_REQUEST = 'CORE_LOAD_EVENTS_REQUEST';
var CORE_LOAD_EVENTS_SUCCESS = 'CORE_LOAD_EVENTS_SUCCESS';
var CORE_LOAD_EVENTS_FAILURE = 'CORE_LOAD_EVENTS_FAILURE';

var CORE_UPDATE_ORDER_REQUEST = 'CORE_UPDATE_ORDER_REQUEST';
var CORE_UPDATE_ORDER_SUCCESS = 'CORE_UPDATE_ORDER_SUCCESS';
var CORE_UPDATE_ORDER_FAILURE = 'CORE_UPDATE_ORDER_FAILURE';

var CORE_LOAD_ORDERS_EVENT_REQUEST = 'CORE_LOAD_ORDERS_EVENT_REQUEST';
var CORE_LOAD_ORDERS_EVENT_SUCCESS = 'CORE_LOAD_ORDERS_EVENT_SUCCESS';
var CORE_LOAD_ORDERS_EVENT_FAILURE = 'CORE_LOAD_ORDERS_EVENT_FAILURE';

var O365_LOAD_EVENTLIST_BETWEEN_REQUEST = 'O365_LOAD_EVENTLIST_BETWEEN_REQUEST';
var O365_LOAD_EVENTLIST_BETWEEN_SUCCESS = 'O365_LOAD_EVENTLIST_BETWEEN_SUCCESS';
var O365_LOAD_EVENTLIST_BETWEEN_FAILURE = 'O365_LOAD_EVENTLIST_BETWEEN_FAILURE';

var CORE_LOAD_SETTING_INFO_REQUEST = 'CORE_LOAD_SETTING_INFO_REQUEST';
var CORE_LOAD_SETTING_INFO_SUCCESS = 'CORE_LOAD_SETTING_INFO_SUCCESS';
var CORE_LOAD_SETTING_INFO_FAILURE = 'CORE_LOAD_SETTING_INFO_FAILURE';

var O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST = 'O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST';
var O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS = 'O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS';
var O365_LOAD_EVENTLISTFULL_BETWEEN_FAILURE = 'O365_LOAD_EVENTLISTFULL_BETWEEN_FAILURE';

var CORE_LOAD_TIMEZOZE_REQUEST = 'CORE_LOAD_TIMEZOZE_REQUEST';
var CORE_LOAD_TIMEZOZE_SUCCESS = 'CORE_LOAD_TIMEZOZE_SUCCESS';
var CORE_LOAD_TIMEZOZE_FAILURE = 'CORE_LOAD_TIMEZOZE_FAILURE';

var CORE_UPDATE_TIMEZONE_REQUEST = 'CORE_UPDATE_TIMEZONE_REQUEST';
var CORE_UPDATE_TIMEZONE_SUCCESS = 'CORE_UPDATE_TIMEZONE_SUCCESS';
var CORE_UPDATE_TIMEZONE_FAILURE = 'CORE_UPDATE_TIMEZONE_FAILURE';

var CORE_LOAD_FOODNEXT_REQUEST = 'CORE_LOAD_FOODNEXT_REQUEST';
var CORE_LOAD_FOODNEXT_SUCCESS = 'CORE_LOAD_FOODNEXT_SUCCESS';
var CORE_LOAD_FOODNEXT_FAILURE = 'CORE_LOAD_FOODNEXT_FAILURE';

var CORE_CANCELEVENTFOOD_REQUEST = 'CORE_CANCELEVENTFOOD_REQUEST';
var CORE_CANCELEVENTFOOD_SUCCESS = 'CORE_CANCELEVENTFOOD_SUCCESS';
var CORE_CANCELEVENTFOOD_FAILURE = 'CORE_CANCELEVENTFOOD_FAILURE';

var CORE_LOAD_AMENITYNEXT_REQUEST = 'CORE_LOAD_AMENITYNEXT_REQUEST';
var CORE_LOAD_AMENITYNEXT_SUCCESS = 'CORE_LOAD_AMENITYNEXT_SUCCESS';
var CORE_LOAD_AMENITYNEXT_FAILURE = 'CORE_LOAD_AMENITYNEXT_FAILURE';

var CORE_DONEAMENITY_REQUEST = 'CORE_DONEAMENITY_REQUEST';
var CORE_DONEAMENITY_FAILURE = 'CORE_DONEAMENITY_FAILURE';
var CORE_DONEAMENITY_SUCCESS = 'CORE_DONEAMENITY_SUCCESS';

var CORE_CANCELEVENTAMENITY_REQUEST = 'CORE_CANCELEVENTAMENITY_REQUEST';
var CORE_CANCELEVENTAMENITY_SUCCESS = 'CORE_CANCELEVENTAMENITY_SUCCESS';
var CORE_CANCELEVENTAMENITY_FAILURE = 'CORE_CANCELEVENTAMENITY_FAILURE';

var CORE_SENDAMENITY_REQUEST = 'CORE_SENDAMENITY_REQUEST';
var CORE_SENDAMENITY_SUCCESS = 'CORE_SENDAMENITY_SUCCESS';
var CORE_SENDAMENITY_FAILURE = 'CORE_SENDAMENITY_FAILURE';

var CORE_LOAD_AMENITYPAST_REQUEST = 'CORE_LOAD_AMENITYPAST_REQUEST';
var CORE_LOAD_AMENITYPAST_SUCCESS = 'CORE_LOAD_AMENITYPAST_SUCCESS';
var CORE_LOAD_AMENITYPAST_FAILURE = 'CORE_LOAD_AMENITYPAST_FAILURE';

var CORE_LOAD_EVENTSERVICEAMENITY_REQUEST = 'CORE_LOAD_EVENTSERVICEAMENITY_REQUEST';
var CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS = 'CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS';
var CORE_LOAD_EVENTSERVICEAMENITY_FAILURE = 'CORE_LOAD_EVENTSERVICEAMENITY_FAILURE';

var CORE_LOAD_AMENITYACTIVE_REQUEST = 'CORE_LOAD_AMENITYACTIVE_REQUEST';
var CORE_LOAD_AMENITYACTIVE_SUCCESS = 'CORE_LOAD_AMENITYACTIVE_SUCCESS';
var CORE_LOAD_AMENITYACTIVE_FAILURE = 'CORE_LOAD_AMENITYACTIVE_FAILURE';

var CORE_LOAD_SUGGEST_INFORMATION_REQUEST = 'CORE_LOAD_SUGGEST_INFORMATION_REQUEST';
var CORE_LOAD_SUGGEST_INFORMATION_SUCCESS = 'CORE_LOAD_SUGGEST_INFORMATION_SUCCESS';
var CORE_LOAD_SUGGEST_INFORMATION_FAILURE = 'CORE_LOAD_SUGGEST_INFORMATION_FAILURE';

var CORE_LOAD_EVENTHOME_REQUEST = 'CORE_LOAD_EVENTHOME_REQUEST';
var CORE_LOAD_EVENTHOME_SUCCESS = 'CORE_LOAD_EVENTHOME_SUCCESS';
var CORE_LOAD_EVENTHOME_FAILURE = 'CORE_LOAD_EVENTHOME_FAILURE';

var CORE_GET_FAVORITEROOM_REQUEST = 'CORE_GET_FAVORITEROOM_REQUEST';
var CORE_GET_FAVORITEROOM_SUCCESS = 'CORE_GET_FAVORITEROOM_SUCCESS';
var CORE_GET_FAVORITEROOM_FAILURE = 'CORE_GET_FAVORITEROOM_FAILURE';

var CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST';
var CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS';
var CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE';

var CORE_INTEGRATION_EXCHANGE_REQUEST = 'CORE_INTEGRATION_EXCHANGE_REQUEST';
var CORE_INTEGRATION_EXCHANGE_SUCCESS = 'CORE_INTEGRATION_EXCHANGE_SUCCESS';
var CORE_INTEGRATION_EXCHANGE_FAILURE = 'CORE_INTEGRATION_EXCHANGE_FAILURE';

var CORE_GETURL_GOOGLE_REQUEST = 'CORE_GETURL_GOOGLE_REQUEST';
var CORE_GETURL_GOOGLE_SUCCESS = 'CORE_GETURL_GOOGLE_SUCCESS';
var CORE_GETURL_GOOGLE_FAILURE = 'CORE_GETURL_GOOGLE_FAILURE';

var CORE_INTEGRATION_GOOGLE_REQUEST = 'CORE_INTEGRATION_GOOGLE_REQUEST';
var CORE_INTEGRATION_GOOGLE_SUCCESS = 'CORE_INTEGRATION_GOOGLE_SUCCESS';
var CORE_INTEGRATION_GOOGLE_FAILURE = 'CORE_INTEGRATION_GOOGLE_FAILURE';

var CORE_GET_FAVORITESEAT_REQUEST = 'CORE_GET_FAVORITESEAT_REQUEST';
var CORE_GET_FAVORITESEAT_SUCCESS = 'CORE_GET_FAVORITESEAT_SUCCESS';
var CORE_GET_FAVORITESEAT_FAILURE = 'CORE_GET_FAVORITESEAT_FAILURE';

var CORE_LOAD_ALL_BUILDING_REQUEST = 'CORE_LOAD_ALL_BUILDING_REQUEST';
var CORE_LOAD_ALL_BUILDING_SUCCESS = 'CORE_LOAD_ALL_BUILDING_SUCCESS';
var CORE_LOAD_ALL_BUILDING_FAILURE = 'CORE_LOAD_ALL_BUILDING_FAILURE';

var CORE_LOAD_ALL_FLOOR_REQUEST = 'CORE_LOAD_ALL_FLOOR_REQUEST';
var CORE_LOAD_ALL_FLOOR_SUCCESS = 'CORE_LOAD_ALL_FLOOR_SUCCESS';
var CORE_LOAD_ALL_FLOOR_FAILURE = 'CORE_LOAD_ALL_FLOOR_FAILURE';

var CORE_LOAD_ALL_ZONE_REQUEST = 'CORE_LOAD_ALL_ZONE_REQUEST';
var CORE_LOAD_ALL_ZONE_SUCCESS = 'CORE_LOAD_ALL_ZONE_SUCCESS';
var CORE_LOAD_ALL_ZONE_FAILURE = 'CORE_LOAD_ALL_ZONE_FAILURE';

var CORE_SUGGEST_SEAT_REQUEST = 'CORE_SUGGEST_SEAT_REQUEST';
var CORE_SUGGEST_SEAT_SUCCESS = 'CORE_SUGGEST_SEAT_SUCCESS';
var CORE_SUGGEST_SEAT_FAILURE = 'CORE_SUGGEST_SEAT_FAILURE';

var CORE_CREATE_EVENT_SEAT_REQUEST = 'CORE_CREATE_EVENT_SEAT_REQUEST';
var CORE_CREATE_EVENT_SEAT_SUCCESS = 'CORE_CREATE_EVENT_SEAT_SUCCESS';
var CORE_CREATE_EVENT_SEAT_FAILURE = 'CORE_CREATE_EVENT_SEAT_FAILURE';

var CORE_DELETE_EVENT_SEAT_REQUEST = 'CORE_DELETE_EVENT_SEAT_REQUEST';
var CORE_DELETE_EVENT_SEAT_SUCCESS = 'CORE_DELETE_EVENT_SEAT_SUCCESS';
var CORE_DELETE_EVENT_SEAT_FAILURE = 'CORE_DELETE_EVENT_SEAT_FAILURE';

var CORE_GET_EVENT_SEATGROUP_REQUEST = 'CORE_GET_EVENT_SEATGROUP_REQUEST';
var CORE_GET_EVENT_SEATGROUP_SUCCESS = 'CORE_GET_EVENT_SEATGROUP_SUCCESS';
var CORE_GET_EVENT_SEATGROUP_FAILURE = 'CORE_GET_EVENT_SEATGROUP_FAILURE';

var CORE_GET_MYEVENT_SEATBYDATE_REQUEST = 'CORE_GET_MYEVENT_SEATBYDATE_REQUEST';
var CORE_GET_MYEVENT_SEATBYDATE_SUCCESS = 'CORE_GET_MYEVENT_SEATBYDATE_SUCCESS';
var CORE_GET_MYEVENT_SEATBYDATE_FAILURE = 'CORE_GET_MYEVENT_SEATBYDATE_FAILURE';

var O365_SUGGEST_ROOM_MEETING_REQUEST = 'O365_SUGGEST_ROOM_MEETING_REQUEST';
var O365_SUGGEST_ROOM_MEETING_SUCCESS = 'O365_SUGGEST_ROOM_MEETING_SUCCESS';
var O365_SUGGEST_ROOM_MEETING_FAILURE = 'O365_SUGGEST_ROOM_MEETING_FAILURE';

var CORE_ADD_FAVORITEROOM_REQUEST = 'CORE_ADD_FAVORITEROOM_REQUEST';
var CORE_ADD_FAVORITEROOM_SUCCESS = 'CORE_ADD_FAVORITEROOM_SUCCESS';
var CORE_ADD_FAVORITEROOM_FAILURE = 'CORE_ADD_FAVORITEROOM_FAILURE';

var CORE_REMOVE_FAVORITEROOM_REQUEST = 'CORE_REMOVE_FAVORITEROOM_REQUEST';
var CORE_REMOVE_FAVORITEROOM_SUCCESS = 'CORE_REMOVE_FAVORITEROOM_SUCCESS';
var CORE_REMOVE_FAVORITEROOM_FAILURE = 'CORE_REMOVE_FAVORITEROOM_FAILURE';

var CORE_LOAD_ALLFACILITIES_REQUEST = 'CORE_LOAD_ALLFACILITIES_REQUEST';
var CORE_LOAD_ALLFACILITIES_SUCCESS = 'CORE_LOAD_ALLFACILITIES_SUCCESS';
var CORE_LOAD_ALLFACILITIES_FAILURE = 'CORE_LOAD_ALLFACILITIES_FAILURE';

var CORE_LOAD_ALLFOODANDBEV_REQUEST = 'CORE_LOAD_ALLFOODANDBEV_REQUEST';
var CORE_LOAD_ALLFOODANDBEV_SUCCESS = 'CORE_LOAD_ALLFOODANDBEV_SUCCESS';
var CORE_LOAD_ALLFOODANDBEV_FAILURE = 'CORE_LOAD_ALLFOODANDBEV_FAILURE';

var CORE_CREATE_AMENITIES_REQUEST = 'CORE_CREATE_AMENITIES_REQUEST';
var CORE_CREATE_AMENITIES_SUCCESS = 'CORE_CREATE_AMENITIES_SUCCESS';
var CORE_CREATE_AMENITIES_FAILURE = 'CORE_CREATE_AMENITIES_FAILURE';

var CORE_LOAD_ORDERAMENITIES_REQUEST = 'CORE_LOAD_ORDERAMENITIES_REQUEST';
var CORE_LOAD_ORDERAMENITIES_SUCCESS = 'CORE_LOAD_ORDERAMENITIES_SUCCESS';
var CORE_LOAD_ORDERAMENITIES_FAILURE = 'CORE_LOAD_ORDERAMENITIES_FAILURE';

var CORE_CREATE_FOODANDBEV_REQUEST = 'CORE_CREATE_FOODANDBEV_REQUEST';
var CORE_CREATE_FOODANDBEV_SUCCESS = 'CORE_CREATE_FOODANDBEV_SUCCESS';
var CORE_CREATE_FOODANDBEV_FAILURE = 'CORE_CREATE_FOODANDBEV_FAILURE';

var CORE_LOAD_ORDERFOODANDBEV_REQUEST = 'CORE_LOAD_ORDERFOODANDBEV_REQUEST';
var CORE_LOAD_ORDERFOODANDBEV_SUCCESS = 'CORE_LOAD_ORDERFOODANDBEV_SUCCESS';
var CORE_LOAD_ORDERFOODANDBEV_FAILURE = 'CORE_LOAD_ORDERFOODANDBEV_FAILURE';

var CORE_LOAD_ORDERINFO_REQUEST = 'CORE_LOAD_ORDERINFO_REQUEST';
var CORE_LOAD_ORDERINFO_SUCCESS = 'CORE_LOAD_ORDERINFO_SUCCESS';
var CORE_LOAD_ORDERINFO_FAILURE = 'CORE_LOAD_ORDERINFO_FAILURE';

var CORE_DELETE_ORDERAMENITY_REQUEST = 'CORE_DELETE_ORDERAMENITY_REQUEST';
var CORE_DELETE_ORDERAMENITY_SUCCESS = 'CORE_DELETE_ORDERAMENITY_SUCCESS';
var CORE_DELETE_ORDERAMENITY_FAILURE = 'CORE_DELETE_ORDERAMENITY_FAILURE';

var CORE_DELETE_ORDERFOODANDBEV_REQUEST = 'CORE_DELETE_ORDERFOODANDBEV_REQUEST';
var CORE_DELETE_ORDERFOODANDBEV_SUCCESS = 'CORE_DELETE_ORDERFOODANDBEV_SUCCESS';
var CORE_DELETE_ORDERFOODANDBEV_FAILURE = 'CORE_DELETE_ORDERFOODANDBEV_FAILURE';

var CORE_UPDATE_ORDERFOODANDBEV_SUCCESS = 'CORE_UPDATE_ORDERFOODANDBEV_REQUEST';
var CORE_UPDATE_ORDERFOODANDBEV_REQUEST = 'CORE_UPDATE_ORDERFOODANDBEV_SUCCESS';
var CORE_UPDATE_ORDERFACILITIES_REQUEST = 'CORE_UPDATE_ORDERFOODANDBEV_FAILURE';

var CORE_UPDATE_ORDERFOODANDBEV_FAILURE = 'CORE_UPDATE_ORDERFACILITIES_REQUEST';
var CORE_UPDATE_ORDERFACILITIES_FAILURE = 'CORE_UPDATE_ORDERFACILITIES_SUCCESS';
var CORE_UPDATE_ORDERFACILITIES_SUCCESS = 'CORE_UPDATE_ORDERFACILITIES_FAILURE';

var CORE_FORGOT_PASSWORD_REQUEST = 'CORE_FORGOT_PASSWORD_REQUEST';
var CORE_FORGOT_PASSWORD_SUCCESS = 'CORE_FORGOT_PASSWORD_SUCCESS';
var CORE_FORGOT_PASSWORD_FAILURE = 'CORE_FORGOT_PASSWORD_FAILURE';

var CORE_CONFIRM_RESET_PASSWORD_REQUEST = 'CORE_CONFIRM_RESET_PASSWORD_REQUEST';
var CORE_CONFIRM_RESET_PASSWORD_SUCCESS = 'CORE_CONFIRM_RESET_PASSWORD_SUCCESS';
var CORE_CONFIRM_RESET_PASSWORD_FAILURE = 'CORE_CONFIRM_RESET_PASSWORD_FAILURE';

var CORE_GET_CAN_BOOKING_REQUEST = 'CORE_GET_CAN_BOOKING_REQUEST';
var CORE_GET_CAN_BOOKING_SUCCESS = 'CORE_GET_CAN_BOOKING_SUCCESS';
var CORE_GET_CAN_BOOKING_FAILURE = 'CORE_GET_CAN_BOOKING_FAILURE';

var CORE_GET_ROOMDISABLE_REQUEST = 'CORE_GET_ROOMDISABLE_REQUEST';
var CORE_GET_ROOMDISABLE_SUCCESS = 'CORE_GET_ROOMDISABLE_SUCCESS';
var CORE_GET_ROOMDISABLE_FAILURE = 'CORE_GET_ROOMDISABLE_FAILURE';

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 502, 503];

function getAction(type, action, state, res) {
	return new Promise(function (resolve, reject) {
		if (!res) return resolve({ type: type });

		if (resStatusError.includes(res.status)) {
			if (res.status === 422) {
				return res.json().then(function (json) {
					var message = "";
					for (var key in json) {
						if (json.hasOwnProperty(key)) {
							var element = json[key];
							for (var k in element) {
								if (element.hasOwnProperty(k)) {
									var ele = element[k];
									message += "" + ele.msg;
									if (ele.param) message += " Param : " + ele.param + " ";
									message += "\n";
								}
							}
						}
					}

					return reject({
						statusText: res.statusText, data: {
							code: res.status.toString(),
							message: message
						}
					});
				});
			} else if (res.status === 404) {
				return reject({
					statusText: 404, data: {
						code: "404",
						message: "404 (Not Found)"
					}
				});
			} else {
				return res.json().then(function (data) {
					return reject({ statusText: res.statusText, data: data });
				});
			}
		}

		if ((typeof type === "undefined" ? "undefined" : _typeof(type)) === 'object') {
			if (type.payload) {
				var payload = type.payload(action, state, res);
				if (typeof payload.then === 'function') {
					//promise
					return payload.then(function (data) {
						return resolve({ type: type.type, payload: data });
					});
				} else {
					return resolve({ type: type.type, payload: payload });
				}
			}

			return resolve({ type: type.type });
		}

		res.json().then(function (payload) {
			return resolve({ type: type, payload: payload });
		});
	});
}

/* harmony default export */ var api = (function (_ref) {
	var getState = _ref.getState;
	return function (next) {
		return function (action) {
			if (_typeof(action[CALL_API]) !== 'object') return next(action);

			var _action$CALL_API = action[CALL_API],
			    endpoint = _action$CALL_API.endpoint,
			    _action$CALL_API$meth = _action$CALL_API.method,
			    method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
			    headers = _action$CALL_API.headers,
			    body = _action$CALL_API.body,
			    types = _action$CALL_API.types;

			var _types = _slicedToArray(types, 3),
			    request = _types[0],
			    success = _types[1],
			    failure = _types[2];

			var callBack = success.callBack;

			var state = getState();

			getAction(request, action, state).then(function (action) {
				return next(action);
			});

			if (callBack) {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					callBack(action);
					next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true });
				});
			} else {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					return next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true });
				});
			}
		};
	};
});
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(400);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./src/lib/index.js + 6 modules
var lib = __webpack_require__(85);

// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            var expire = Object(lib["m" /* getTokenExpire */])();

            var currentTime = moment_timezone_default()().tz(Object(lib["k" /* getTimeZone */])());
            var duration = moment_timezone_default.a.duration(moment_timezone_default.a.unix(expire).diff(currentTime));
            var minutes = duration.asMinutes();
            if (minutes < 5) {
                fetch(lib["a" /* CORE_API_ENDPOINT */] + '/user/newtoken', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + Object(lib["g" /* getBSRSToken */])()
                    }
                }).then(function (res) {
                    return res.json();
                }).then(function (json) {
                    return Object(lib["s" /* setRefreshToken */])(json);
                }).then(function () {
                    return next(action);
                });
            } else {
                next(action);
            }
            // }else{
            //     next(action)
            // }  
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
  return function (next) {
    return function (action) {
      var entry = action[CALL_API];

      if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

      var token = void 0;
      var entryType = entry.types[0];

      if (entryType.startsWith("CORE") || entry.types[0].startsWith("O365") || entry.types[0].startsWith("SERVICE")) {
        token = Object(lib["g" /* getBSRSToken */])();
      }
      // else if (entry.types[0].startsWith("SERVICE")) {
      //   token = getO365Token()
      // }

      if (!token) return next(action);

      entry.headers = _extends({}, entry.headers, { 'Authorization': 'Bearer ' + token });

      next(action);
    };
  };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(133);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Loading = function Loading() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["f" /* Dimmer */],
        { active: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["m" /* Image */], { src: '/assets/images/47tj.gif', style: { display: "inline", width: '100px' } })
    );
};

/* harmony default export */ __webpack_exports__["a"] = (function (opts) {
    return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()(_extends({
        loading: Loading
    }, opts));
});

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(425);


/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__);





var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

render(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return render(RootContainer);
    });
}

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(433);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 15 modules
var es = __webpack_require__(69);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/src/index.js
var src = __webpack_require__(439);
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new src["schema"].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(445);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(68);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(133);

// CONCATENATED MODULE: ./src/features/ui/selectors.js
function getIsLoading(state) {
    return state.ui.isLoading;
}

function getHasError(state) {
    return state.ui.hasError;
}

function getHasBSRSLoginFail(state) {
    return state.ui.hasBSRSLoginFail === true;
}

function getErrorMessage(state) {
    return state.ui.errorMessage;
}

function getErrorCode(state) {
    return state.ui.errorCode;
}

function getUiMessage(state) {
    return state.ui;
}

function getError(state) {
    return state.ui.error;
}
// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(16);

// CONCATENATED MODULE: ./src/error.js

// 0000 => api error
// 0001 => backend error
// 0002 => fronted error

var errorMessage = {
	// default error
	"00010000": "Something went wrong. Please try again later.",

	// custom error
	"00010001": "asfsdfdsfdsf sdfdsf dsf"
};

/* harmony default export */ var src_error = ({
	errorMessage: errorMessage
});
// CONCATENATED MODULE: ./src/features/ui/actions.js





function setError(hasError) {
	var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var defaultError = {
		code: "00010000",
		message: src_error.errorMessage["00010000"]
	};

	if (typeof error === 'string' && error in src_error.errorMessage) {
		defaultError = {
			code: error,
			message: src_error.errorMessage[error]
		};
	} else if (error !== null && error.code !== undefined && error.message !== undefined) {
		defaultError = error;
	} else if (error === null || hasError === false) {
		defaultError = null;
	}

	return {
		type: types["_242" /* SET_ERROR */],
		hasError: hasError,
		error: defaultError
	};
}
// CONCATENATED MODULE: ./src/features/ui/components/ErrorMessageDialog.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








__webpack_require__(707);

var ErrorMessageDialog_ErrorMessage = function (_React$Component) {
	_inherits(ErrorMessage, _React$Component);

	function ErrorMessage() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ErrorMessage);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorMessage.__proto__ || Object.getPrototypeOf(ErrorMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.hasError }, _this.close = function () {
			_this.setState({ open: false });
			_this.props.clearError();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ErrorMessage, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProp) {
			this.setState({ open: nextProp.hasError });
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				dist_es["t" /* Modal */],
				{ open: this.state.open, onClose: this.close, size: 'small' },
				react_default.a.createElement(
					dist_es["t" /* Modal */].Content,
					{ style: { height: 'auto' } },
					react_default.a.createElement(
						'div',
						{ className: 'errormessage' },
						react_default.a.createElement(
							'div',
							{ className: 'contenterror' },
							react_default.a.createElement(
								'div',
								{ className: 'content-image' },
								react_default.a.createElement(dist_es["m" /* Image */], { src: '/assets/images/icon-warning-red.png' })
							),
							react_default.a.createElement(
								'div',
								{ className: 'content-text' },
								react_default.a.createElement('p', null),
								this.props.hasError && this.props.error != null && this.props.error.code !== undefined && this.props.error.message !== undefined ? react_default.a.createElement(
									'p',
									null,
									this.props.error.message
								) : react_default.a.createElement(
									'p',
									null,
									'Something went wrong.'
								)
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'close', onClick: this.close },
							react_default.a.createElement(dist_es["m" /* Image */], { src: '/assets/images/icon-cross-red.png' })
						)
					)
				)
			);
		}
	}]);

	return ErrorMessage;
}(react_default.a.Component);

/* harmony default export */ var ErrorMessageDialog = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state, props) {
	return {
		hasError: getHasError(state),
		error: getError(state)
	};
}, function (dispatch) {
	return {
		clearError: function clearError() {
			dispatch(setError(false));
		}
	};
}))(ErrorMessageDialog_ErrorMessage));
// CONCATENATED MODULE: ./src/features/ui/components/Loading.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var Loading_LoadingComponent = function LoadingComponent(props) {
	return props.isLoading ? react_default.a.createElement(
		dist_es["f" /* Dimmer */],
		{ active: true },
		react_default.a.createElement(dist_es["m" /* Image */], { src: '/assets/images/47tj.gif', style: { display: "inline", width: '100px' } })
	) : "";
};

/* harmony default export */ var Loading = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state) {
	return {
		isLoading: getIsLoading(state)
	};
}), Object(Recompose["f" /* withProps */])(function (props) {
	return _extends({}, props);
}))(Loading_LoadingComponent));
// EXTERNAL MODULE: ./src/features/ui/components/Loadable.js
var Loadable = __webpack_require__(399);

// EXTERNAL MODULE: ./src/lib/index.js + 6 modules
var lib = __webpack_require__(85);

// CONCATENATED MODULE: ./src/lib/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Auth = {
	isAuthenticated: function isAuthenticated() {
		var bsrsToken = Object(lib["g" /* getBSRSToken */])();
		// const serviceToken = getAccessToken()

		return !!bsrsToken; /*&& !!serviceToken*/
	},
	isIntegration: function isIntegration() {
		// const o365Token = getO365Token()
		var isIntegration = Object(lib["h" /* getIsIntegration */])();
		var setIsIntegration = typeof isIntegration === 'boolean' ? isIntegration : false;
		if (typeof isIntegration === 'string' && isIntegration.toLowerCase() === 'true') {
			setIsIntegration = true;
		}

		if (typeof setIsIntegration === 'boolean') {
			return !!setIsIntegration;
		}
	}
};

var routePermission_PrivateRoute = function PrivateRoute(_ref) {
	var Component = _ref.component,
	    rest = _objectWithoutProperties(_ref, ['component']);

	return react_default.a.createElement(es["d" /* Route */], routePermission__extends({ onUpdate: function onUpdate() {
			return window.scrollTo(0, 0);
		} }, rest, { render: function render(props) {
			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/login' });
			}

			if (Auth.isIntegration() === false && props.match.url !== "/integration") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/integration' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				// return <Redirect to='/' />
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/searchroom' });
			}
		} }));
};

var routePermission_PublicRoute = function PublicRoute(_ref2) {
	var Component = _ref2.component,
	    rest = _objectWithoutProperties(_ref2, ['component']);

	return react_default.a.createElement(es["d" /* Route */], routePermission__extends({ onUpdate: function onUpdate() {
			return window.scrollTo(0, 0);
		} }, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === true && props.match.url === "/login") {
				// return <Redirect to='/' />
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/searchroom' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return "";
			}
		} }));
};


// CONCATENATED MODULE: ./src/features/ui/components/Routes.js





var AsyncHome = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 1869));
    }
});

var AsyncNotFound = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1870));
    }
});

var AsyncLoginO365 = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1871));
    }
});

var AsyncLoginBSRS = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1872));
    }
});

var AsyncAuthorizeO365 = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1874));
    }
});

var AsyncEventDetail = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1875));
    }
});

var AsyncRoomsInEvent = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1876));
    }
});

var AsyncMyInformation = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1877));
    }
});

var AsyncCreateOrder = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1878));
    }
});

var AsyncSettings = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1880));
    }
});

var AsyncSettingsIntegrations = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1881));
    }
});

var AsyncGoogleCallback = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1883));
    }
});

var AsyncUserInfo = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1884));
    }
});

var AsyncUserInformation = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1885));
    }
});

var AsyncEditUserInformation = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1886));
    }
});

// const AsyncUserChangePassword = Loadable({
//     loader: () => import('Features/user/components/UserChangePassword')
// })

var AsyncChangePassword = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1887));
    }
});

var AsyncTerm = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1888));
    }
});

var AsyncContact = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1889));
    }
});

var AsyncFaq = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1890));
    }
});

// const AsyncIntegrationInfo = Loadable({
//     loader: () => import('Features/user/components/IntegrationInfo')
// })

var AsyncViewEvent = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1891));
    }
});

var AsyncAmenityService = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1892));
    }
});

var AsyncIntegrationInfo = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1894));
    }
});

var AsyncIntegrationExchange = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1895));
    }
});

var AsyncRooms = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1896));
    }
});

var AsyncHistory = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1897));
    }
});

// const AsyncSearchRoom = Loadable({
//     loader: () => import('../../rooms/components/pages/searchRoom')
// })

var AsyncSuggestRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1898));
    }
});

var AsyncCreateEvent = Object(Loadable["a" /* default */])({
    // oader: () => import('../../events/components/pages/createEvent')
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1901));
    }
});

var AsyncUpdateEvent = Object(Loadable["a" /* default */])({
    // loader: () => import('../../events/components/pages/updateEvent')
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1902));
    }
});

var AsyncEventSuccess = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1903));
    }
});

var AsyncRoomInfo = Object(Loadable["a" /* default */])({
    // loader: () => import('../../rooms/components/pages/roominfo')
    loader: function loader() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1904));
    }

});

var AsyncMeetingRooms = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1905));
    }
});

var AsyncMenu = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1906));
    }
});

var AsyncScanQR = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1907));
    }
});

var AsyncTest = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1908));
    }
});

var AsyncAdvancedSearch = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1909));
    }
});

var AsyncAdvancedSearchResult = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1910));
    }
});

var AsyncHomeHistory = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 1869));
    }
});

var AsyncRoomList = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1911));
    }
});

var AsyncMyReservation = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1914));
    }
});

var AsyncHotdesk = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1916));
    }
});

var AsyncBuildingList = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1917));
    }
});

var AsyncFloorList = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1918));
    }
});

var AsyncZoneList = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1919));
    }
});

var AsyncCreateEventHotdesk = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1920));
    }
});

var AsyncEventHotdeskSuccess = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1921));
    }
});

var AsyncHotdeskMyReservation = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1922));
    }
});

var AsyncServiceDetail = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1923));
    }
});

var AsyncServiceAllFacilities = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1924));
    }
});

var AsyncServiceAllFoodAndBevs = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1925));
    }
});

var AsyncServiceAllRequestList = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1926));
    }
});

var AsyncServiceEditOrderFacility = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1927));
    }
});

var AsyncServiceEditOrderfoodAndBev = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1928));
    }
});

var AsyncConfirmResetPassword = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1929));
    }
});

var AsyncMyQrCode = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1930));
    }
});

var AsyncScanQrCode = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1931));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        es["e" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/', component: AsyncHome }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/login', component: AsyncLoginBSRS }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/resetpassword/:key', component: AsyncConfirmResetPassword }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/logino365', component: AsyncLoginO365 }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/myqrcode/:id', component: AsyncMyQrCode }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/scanqr', component: AsyncScanQrCode }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/authorize', component: AsyncAuthorizeO365 }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/google/authencallback', component: AsyncGoogleCallback }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/events/new/:date/:start/:endDate/:end/:roomsEmail', component: AsyncCreateEvent }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/events/update/:typeEdit/:email/:eventId', component: AsyncUpdateEvent }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/events/success/:action/:eventId', component: AsyncEventSuccess }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/service/all/requestList', component: AsyncServiceAllRequestList }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/service/edit/facility/:id', component: AsyncServiceEditOrderFacility }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/service/edit/foodAndBev/:id', component: AsyncServiceEditOrderfoodAndBev }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/events/success/:action', component: AsyncEventSuccess }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/service/all/facilities', component: AsyncServiceAllFacilities }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/service/all/foodAndBevs', component: AsyncServiceAllFoodAndBevs }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/service/:email/:icaluid', component: AsyncServiceDetail }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/history/event/:email/:eventId', component: AsyncEventDetail }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/roomsorder/event/:email/:eventId', component: AsyncRoomsInEvent }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/events', component: AsyncMyReservation }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/scanQR', component: AsyncScanQR }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/info', component: AsyncMyInformation }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/order/create/:type/:roomEmail/:eventId/:iCalUId', component: AsyncCreateOrder }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/settings/integrations', component: AsyncSettingsIntegrations }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/settings', component: AsyncSettings }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/userinfo', component: AsyncUserInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/userinformation', component: AsyncUserInformation }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/changeInformation/:id', component: AsyncEditUserInformation }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/term', component: AsyncTerm }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/contact', component: AsyncContact }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/integration/exchange', component: AsyncIntegrationExchange }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/integration', component: AsyncIntegrationInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/faq', component: AsyncFaq }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/changepassword/:id', component: AsyncChangePassword }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/vieworder/:type/:id', component: AsyncViewEvent }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/amenityservice', component: AsyncAmenityService }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/rooms', component: AsyncRooms }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/history', component: AsyncHistory }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/menu', component: AsyncMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/roominfo/:email', component: AsyncRoomInfo }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/searchroom', component: AsyncAdvancedSearch }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/searchroomresult/:body', component: AsyncAdvancedSearchResult }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/roomlist', component: AsyncRoomList }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/meetingrooms', component: AsyncMeetingRooms }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/suggest', component: AsyncSuggestRoom }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/homehistory', component: AsyncHomeHistory }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/myreservation', component: AsyncMyReservation }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/hotdesk', component: AsyncHotdesk }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/building', component: AsyncBuildingList }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/floor/:buildingId', component: AsyncFloorList }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/zone/:buildingId/:floorId', component: AsyncZoneList }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/createeventhotdesk/:buildingId/:floorId/:zoneId', component: AsyncCreateEventHotdesk }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/eventhotdesksuccess/:eventId', component: AsyncEventHotdeskSuccess }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/hotdeskmyreservation', component: AsyncHotdeskMyReservation }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/test', component: AsyncTest }),
        react_default.a.createElement(routePermission_PrivateRoute, { component: AsyncNotFound })
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/App.js

// import Header from './Header'
// import Breadcrumb from './Breadcrumb'

// import Footer from './Footer'
// import { Container } from 'semantic-ui-react'

/* harmony default export */ var App = (function () {
    return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(Routes, null)
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/Root.prod.js








var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
	return react_default.a.createElement(
		react_redux_es["Provider"],
		{ store: store },
		react_default.a.createElement(
			'div',
			null,
			react_default.a.createElement(
				es["a" /* BrowserRouter */],
				null,
				react_default.a.createElement(App, null)
			),
			react_default.a.createElement(ErrorMessageDialog, null),
			react_default.a.createElement(Loading, null)
		)
	);
});

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(446);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(74);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var lib = __webpack_require__(447);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(398);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 225 modules
var redux_form_es = __webpack_require__(423);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var reapop_lib = __webpack_require__(457);
var reapop_lib_default = /*#__PURE__*/__webpack_require__.n(reapop_lib);

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(16);

// EXTERNAL MODULE: ./src/lib/index.js + 6 modules
var src_lib = __webpack_require__(85);

// CONCATENATED MODULE: ./src/features/auth/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var allToken = Object(src_lib["f" /* getAllToken */])();
var bsrsToken = Object(src_lib["g" /* getBSRSToken */])();

var reducer_initialState = {
  token: allToken,
  bsrsToken: bsrsToken,
  user: Object(src_lib["p" /* getUserInfo */])(allToken.access_token)
};

/* harmony default export */ var reducer = ({
  authen: function authen() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_208" /* O365_REGISTER_SUCCESS */]:
        {
          return _extends({}, state, {
            token: _extends({}, action.payload.token),
            user: Object(src_lib["p" /* getUserInfo */])(action.payload.token.access_token)
          });
        }
      case types["c" /* BSRS_LOGIN_SUCCESS */]:
        {
          return _extends({}, state, {
            bsrsToken: action.payload.bsrsToken,
            user: action.payload
          });
        }
      case types["_169" /* LOGOUT */]:
        return _extends({}, state, {
          bsrsToken: undefined
        });
      default:
        return state;
    }
  },
  forgotPassword: function forgotPassword() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["X" /* CORE_FORGOT_PASSWORD_REQUEST */]:
        return {};
      case types["Y" /* CORE_FORGOT_PASSWORD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  resetPassword: function resetPassword() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["t" /* CORE_CONFIRM_RESET_PASSWORD_REQUEST */]:
        return {};
      case types["u" /* CORE_CONFIRM_RESET_PASSWORD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/user/reducer.js


var user_reducer_initialState = [];

/* harmony default export */ var user_reducer = ({
  users: function users() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_225" /* O365_USER_LIST_REQUEST */]:
      case types["_237" /* SERVICE_SEARCH_USERS_REQUEST */]:
        return user_reducer_initialState;
      case types["_226" /* O365_USER_LIST_SUCCESS */]:
      case types["_238" /* SERVICE_SEARCH_USERS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  user: function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_131" /* CORE_LOAD_USER_INFO_REQUEST */]:
      case types["_204" /* O365_LOAD_USER_INFO_REQUEST */]:
        return {};
      case types["_132" /* CORE_LOAD_USER_INFO_SUCCESS */]:
      case types["_205" /* O365_LOAD_USER_INFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  integration: function integration() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_95" /* CORE_LOAD_INTEGRATION_REQUEST */]:
      case types["_138" /* CORE_REMOVE_INTEGRATION_SUCCESS */]:
        return {};
      case types["_96" /* CORE_LOAD_INTEGRATION_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  o365Url: function o365Url() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_98" /* CORE_LOAD_O365URL_REQUEST */]:
        return {};
      case types["_99" /* CORE_LOAD_O365URL_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  urlGoogle: function urlGoogle() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_0" /* CORE_GETURL_GOOGLE_REQUEST */]:
        return null;
      case types["_1" /* CORE_GETURL_GOOGLE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/ui/reducer.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var ui_reducer_initialState = {
	hasError: false,
	isLoading: false,
	error: null
};
/* harmony default export */ var ui_reducer = (function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ui_reducer_initialState;
	var action = arguments[1];


	switch (action.type) {
		case types["_207" /* O365_REGISTER_REQUEST */]:
		case types["_198" /* O365_LOAD_EVENTS_REQUEST */]:
		case types["_201" /* O365_LOAD_EVENT_REQUEST */]:
		case types["_204" /* O365_LOAD_USER_INFO_REQUEST */]:
		case types["_177" /* O365_CREATE_EVENT_REQUEST */]:
		case types["_183" /* O365_DELETE_EVENT_REQUEST */]:
		case types["_171" /* O365_ACCEPT_EVENT_REQUEST */]:
		case types["_219" /* O365_TENTATIVE_EVENT_REQUEST */]:
		case types["_180" /* O365_DECLINE_EVENT_REQUEST */]:
		case types["_113" /* CORE_LOAD_ORDERS_REQUEST */]:
		case types["_131" /* CORE_LOAD_USER_INFO_REQUEST */]:
		case types["_125" /* CORE_LOAD_TERM_REQUEST */]:
		case types["_62" /* CORE_LOAD_CONTACT_REQUEST */]:
		case types["_80" /* CORE_LOAD_FAQ_REQUEST */]:
		case types["_95" /* CORE_LOAD_INTEGRATION_REQUEST */]:
		case types["_167" /* CORE_USER_INTEGRATION_REQUEST */]:
		case types["_98" /* CORE_LOAD_O365URL_REQUEST */]:
		case types["n" /* CORE_CHANGE_PASSWORD_REQUEST */]:
		case types["_21" /* CORE_GET_ROOM_INFO_REQUEST */]:
		case types["_24" /* CORE_GET_ROOM_STATUS_REQUEST */]:
		case types["_195" /* O365_LOAD_EVENTLIST_REQUEST */]:
		case types["_186" /* O365_LOAD_EVENTDETAIL_REQUEST */]:
		case types["q" /* CORE_CHECKIN_REQUEST */]:
		case types["_174" /* O365_CHECKOUT_REQUEST */]:
		case types["_216" /* O365_SUGGEST_ROOM_REQUEST */]:
		case types["_222" /* O365_UPDATE_EVENT_REQUEST */]:
		case types["b" /* BSRS_LOGIN_REQUEST */]:
		case types["_89" /* CORE_LOAD_FOODNEXT_REQUEST */]:
		case types["_146" /* CORE_SENDFOOD_REQUEST */]:
		case types["U" /* CORE_DONEFOOD_REQUEST */]:
		case types["_68" /* CORE_LOAD_EVENTINFOSERVICE_REQUEST */]:
		case types["_158" /* CORE_UPDATE_ORDER_REQUEST */]:
		case types["F" /* CORE_CREATE_ORDER_REQUEST */]:
		case types["_83" /* CORE_LOAD_FBS_REQUEST */]:
		case types["_77" /* CORE_LOAD_EVENTS_REQUEST */]:
		case types["_237" /* SERVICE_SEARCH_USERS_REQUEST */]:
		case types["_110" /* CORE_LOAD_ORDERS_EVENT_REQUEST */]:
		case types["_192" /* O365_LOAD_EVENTLIST_BETWEEN_REQUEST */]:
		case types["_234" /* SERVICE_DELETE_EVENT_REQUEST */]:
		case types["_189" /* O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST */]:
		case types["_161" /* CORE_UPDATE_TIMEZONE_REQUEST */]:
		case types["_122" /* CORE_LOAD_SUGGEST_INFORMATION_REQUEST */]:
		case types["_210" /* O365_SUGGESTTION_REQUEST */]:
		case types["_164" /* CORE_UPDATE_USER_REQUEST */]:
		case types["_12" /* CORE_GET_FAVORITESEAT_REQUEST */]:
		case types["_44" /* CORE_LOAD_ALL_BUILDING_REQUEST */]:
		case types["_47" /* CORE_LOAD_ALL_FLOOR_REQUEST */]:
		case types["_50" /* CORE_LOAD_ALL_ZONE_REQUEST */]:
		case types["_149" /* CORE_SUGGEST_SEAT_REQUEST */]:
		case types["z" /* CORE_CREATE_EVENT_SEAT_REQUEST */]:
		case types["_6" /* CORE_GET_EVENT_SEATGROUP_REQUEST */]:
		case types["_15" /* CORE_GET_MYEVENT_SEATBYDATE_REQUEST */]:
		case types["_140" /* CORE_SEARCH_ROOM_REQUEST */]:
		case types["e" /* CORE_ADD_FAVORITEROOM_REQUEST */]:
		case types["_134" /* CORE_REMOVE_FAVORITEROOM_REQUEST */]:
		case types["I" /* CORE_DELETE_EVENT_SEAT_REQUEST */]:
		case types["L" /* CORE_DELETE_ORDERAMENITY_REQUEST */]:
		case types["O" /* CORE_DELETE_ORDERFOODANDBEV_REQUEST */]:
		case types["_107" /* CORE_LOAD_ORDERINFO_REQUEST */]:
		case types["w" /* CORE_CREATE_AMENITIES_REQUEST */]:
		case types["C" /* CORE_CREATE_FOODANDBEV_REQUEST */]:
		case types["X" /* CORE_FORGOT_PASSWORD_REQUEST */]:
		case types["t" /* CORE_CONFIRM_RESET_PASSWORD_REQUEST */]:
		case types["_18" /* CORE_GET_ROOMDISABLE_REQUEST */]:
			return reducer__extends({}, state, {
				isLoading: true,
				hasError: false,
				error: null
			});
		case types["_208" /* O365_REGISTER_SUCCESS */]:
		case types["_199" /* O365_LOAD_EVENTS_SUCCESS */]:
		case types["_202" /* O365_LOAD_EVENT_SUCCESS */]:
		case types["_205" /* O365_LOAD_USER_INFO_SUCCESS */]:
		case types["_178" /* O365_CREATE_EVENT_SUCCESS */]:
		case types["_184" /* O365_DELETE_EVENT_SUCCESS */]:
		case types["_172" /* O365_ACCEPT_EVENT_SUCCESS */]:
		case types["_220" /* O365_TENTATIVE_EVENT_SUCCESS */]:
		case types["_181" /* O365_DECLINE_EVENT_SUCCESS */]:
		case types["_114" /* CORE_LOAD_ORDERS_SUCCESS */]:
		case types["_132" /* CORE_LOAD_USER_INFO_SUCCESS */]:
		case types["_126" /* CORE_LOAD_TERM_SUCCESS */]:
		case types["_63" /* CORE_LOAD_CONTACT_SUCCESS */]:
		case types["_81" /* CORE_LOAD_FAQ_SUCCESS */]:
		case types["_96" /* CORE_LOAD_INTEGRATION_SUCCESS */]:
		case types["_168" /* CORE_USER_INTEGRATION_SUCCESS */]:
		case types["_99" /* CORE_LOAD_O365URL_SUCCESS */]:
		case types["o" /* CORE_CHANGE_PASSWORD_SUCCESS */]:
		case types["_22" /* CORE_GET_ROOM_INFO_SUCCESS */]:
		case types["_25" /* CORE_GET_ROOM_STATUS_SUCCESS */]:
		case types["_196" /* O365_LOAD_EVENTLIST_SUCCESS */]:
		case types["_187" /* O365_LOAD_EVENTDETAIL_SUCCESS */]:
		case types["r" /* CORE_CHECKIN_SUCCESS */]:
		case types["_175" /* O365_CHECKOUT_SUCCESS */]:
		case types["_217" /* O365_SUGGEST_ROOM_SUCCESS */]:
		case types["_223" /* O365_UPDATE_EVENT_SUCCESS */]:
		case types["c" /* BSRS_LOGIN_SUCCESS */]:
		case types["_90" /* CORE_LOAD_FOODNEXT_SUCCESS */]:
		case types["_147" /* CORE_SENDFOOD_SUCCESS */]:
		case types["V" /* CORE_DONEFOOD_SUCCESS */]:
		case types["_69" /* CORE_LOAD_EVENTINFOSERVICE_SUCCESS */]:
		case types["_159" /* CORE_UPDATE_ORDER_SUCCESS */]:
		case types["G" /* CORE_CREATE_ORDER_SUCCESS */]:
		case types["_84" /* CORE_LOAD_FBS_SUCCESS */]:
		case types["_78" /* CORE_LOAD_EVENTS_SUCCESS */]:
		case types["_238" /* SERVICE_SEARCH_USERS_SUCCESS */]:
		case types["_111" /* CORE_LOAD_ORDERS_EVENT_SUCCESS */]:
		case types["_193" /* O365_LOAD_EVENTLIST_BETWEEN_SUCCESS */]:
		case types["_235" /* SERVICE_DELETE_EVENT_SUCCESS */]:
		case types["_190" /* O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS */]:
		case types["_162" /* CORE_UPDATE_TIMEZONE_SUCCESS */]:
		case types["_123" /* CORE_LOAD_SUGGEST_INFORMATION_SUCCESS */]:
		case types["_211" /* O365_SUGGESTTION_SUCCESS */]:
		case types["_165" /* CORE_UPDATE_USER_SUCCESS */]:
		case types["_13" /* CORE_GET_FAVORITESEAT_SUCCESS */]:
		case types["_45" /* CORE_LOAD_ALL_BUILDING_SUCCESS */]:
		case types["_48" /* CORE_LOAD_ALL_FLOOR_SUCCESS */]:
		case types["_51" /* CORE_LOAD_ALL_ZONE_SUCCESS */]:
		case types["_150" /* CORE_SUGGEST_SEAT_SUCCESS */]:
		case types["A" /* CORE_CREATE_EVENT_SEAT_SUCCESS */]:
		case types["_7" /* CORE_GET_EVENT_SEATGROUP_SUCCESS */]:
		case types["_16" /* CORE_GET_MYEVENT_SEATBYDATE_SUCCESS */]:
		case types["_141" /* CORE_SEARCH_ROOM_SUCCESS */]:
		case types["f" /* CORE_ADD_FAVORITEROOM_SUCCESS */]:
		case types["_135" /* CORE_REMOVE_FAVORITEROOM_SUCCESS */]:
		case types["J" /* CORE_DELETE_EVENT_SEAT_SUCCESS */]:
		case types["M" /* CORE_DELETE_ORDERAMENITY_SUCCESS */]:
		case types["P" /* CORE_DELETE_ORDERFOODANDBEV_SUCCESS */]:
		case types["_108" /* CORE_LOAD_ORDERINFO_SUCCESS */]:
		case types["x" /* CORE_CREATE_AMENITIES_SUCCESS */]:
		case types["D" /* CORE_CREATE_FOODANDBEV_SUCCESS */]:
		case types["Y" /* CORE_FORGOT_PASSWORD_SUCCESS */]:
		case types["u" /* CORE_CONFIRM_RESET_PASSWORD_SUCCESS */]:
		case types["_19" /* CORE_GET_ROOMDISABLE_SUCCESS */]:
			return reducer__extends({}, state, {
				isLoading: false,
				hasError: false,
				error: null
			});

		case types["_203" /* O365_LOAD_USER_INFO_FAILURE */]:
		case types["_200" /* O365_LOAD_EVENT_FAILURE */]:
		case types["_197" /* O365_LOAD_EVENTS_FAILURE */]:
		case types["_176" /* O365_CREATE_EVENT_FAILURE */]:
		case types["_182" /* O365_DELETE_EVENT_FAILURE */]:
		case types["_170" /* O365_ACCEPT_EVENT_FAILURE */]:
		case types["_218" /* O365_TENTATIVE_EVENT_FAILURE */]:
		case types["_179" /* O365_DECLINE_EVENT_FAILURE */]:
		case types["_112" /* CORE_LOAD_ORDERS_FAILURE */]:
		case types["_130" /* CORE_LOAD_USER_INFO_FAILURE */]:
		case types["_124" /* CORE_LOAD_TERM_FAILURE */]:
		case types["_61" /* CORE_LOAD_CONTACT_FAILURE */]:
		case types["_79" /* CORE_LOAD_FAQ_FAILURE */]:
		case types["_94" /* CORE_LOAD_INTEGRATION_FAILURE */]:
		case types["_166" /* CORE_USER_INTEGRATION_FAILURE */]:
		case types["_206" /* O365_REGISTER_FAILURE */]:
		case types["_97" /* CORE_LOAD_O365URL_FAILURE */]:
		case types["m" /* CORE_CHANGE_PASSWORD_FAILURE */]:
		case types["_20" /* CORE_GET_ROOM_INFO_FAILURE */]:
		case types["_23" /* CORE_GET_ROOM_STATUS_FAILURE */]:
		case types["_194" /* O365_LOAD_EVENTLIST_FAILURE */]:
		case types["_185" /* O365_LOAD_EVENTDETAIL_FAILURE */]:
		case types["p" /* CORE_CHECKIN_FAILURE */]:
		case types["_173" /* O365_CHECKOUT_FAILURE */]:
		case types["_212" /* O365_SUGGEST_ROOM_FAILURE */]:
		case types["_221" /* O365_UPDATE_EVENT_FAILURE */]:
		case types["a" /* BSRS_LOGIN_FAILURE */]:
		case types["_88" /* CORE_LOAD_FOODNEXT_FAILURE */]:
		case types["_145" /* CORE_SENDFOOD_FAILURE */]:
		case types["T" /* CORE_DONEFOOD_FAILURE */]:
		case types["_67" /* CORE_LOAD_EVENTINFOSERVICE_FAILURE */]:
		case types["_157" /* CORE_UPDATE_ORDER_FAILURE */]:
		case types["E" /* CORE_CREATE_ORDER_FAILURE */]:
		case types["_82" /* CORE_LOAD_FBS_FAILURE */]:
		case types["_76" /* CORE_LOAD_EVENTS_FAILURE */]:
		case types["_236" /* SERVICE_SEARCH_USERS_FAILURE */]:
		case types["_109" /* CORE_LOAD_ORDERS_EVENT_FAILURE */]:
		case types["_191" /* O365_LOAD_EVENTLIST_BETWEEN_FAILURE */]:
		case types["_233" /* SERVICE_DELETE_EVENT_FAILURE */]:
		case types["_188" /* O365_LOAD_EVENTLISTFULL_BETWEEN_FAILURE */]:
		case types["_160" /* CORE_UPDATE_TIMEZONE_FAILURE */]:
		case types["_121" /* CORE_LOAD_SUGGEST_INFORMATION_FAILURE */]:
		case types["_209" /* O365_SUGGESTTION_FAILURE */]:
		case types["_163" /* CORE_UPDATE_USER_FAILURE */]:
		case types["_11" /* CORE_GET_FAVORITESEAT_FAILURE */]:
		case types["_43" /* CORE_LOAD_ALL_BUILDING_FAILURE */]:
		case types["_46" /* CORE_LOAD_ALL_FLOOR_FAILURE */]:
		case types["_49" /* CORE_LOAD_ALL_ZONE_FAILURE */]:
		case types["_148" /* CORE_SUGGEST_SEAT_FAILURE */]:
		case types["y" /* CORE_CREATE_EVENT_SEAT_FAILURE */]:
		case types["_5" /* CORE_GET_EVENT_SEATGROUP_FAILURE */]:
		case types["_14" /* CORE_GET_MYEVENT_SEATBYDATE_FAILURE */]:
		case types["_139" /* CORE_SEARCH_ROOM_FAILURE */]:
		case types["d" /* CORE_ADD_FAVORITEROOM_FAILURE */]:
		case types["_133" /* CORE_REMOVE_FAVORITEROOM_FAILURE */]:
		case types["H" /* CORE_DELETE_EVENT_SEAT_FAILURE */]:
		case types["K" /* CORE_DELETE_ORDERAMENITY_FAILURE */]:
		case types["N" /* CORE_DELETE_ORDERFOODANDBEV_FAILURE */]:
		case types["_106" /* CORE_LOAD_ORDERINFO_FAILURE */]:
		case types["v" /* CORE_CREATE_AMENITIES_FAILURE */]:
		case types["B" /* CORE_CREATE_FOODANDBEV_FAILURE */]:
		case types["W" /* CORE_FORGOT_PASSWORD_FAILURE */]:
		case types["s" /* CORE_CONFIRM_RESET_PASSWORD_FAILURE */]:
		case types["_17" /* CORE_GET_ROOMDISABLE_FAILURE */]:
			var returnData = reducer__extends({}, state, {
				isLoading: false,
				hasError: true,
				error: action.payload.data
			});
			return returnData;
		case types["_242" /* SET_ERROR */]:
			return reducer__extends({}, state, {
				hasError: action.hasError,
				error: action.error
			});
		default:
			return state;
	}
});
// CONCATENATED MODULE: ./src/features/fb/reducer.js


var fb_reducer_initialState = [];

/* harmony default export */ var fb_reducer = ({
  orders: function orders() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fb_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_83" /* CORE_LOAD_FBS_REQUEST */]:
        return [];
      case types["_84" /* CORE_LOAD_FBS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/order/reducer.js


var order_reducer_initialState = [];

/* harmony default export */ var order_reducer = ({
  ordersRoom: function ordersRoom() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_110" /* CORE_LOAD_ORDERS_EVENT_REQUEST */]:
        return [];
      case types["_111" /* CORE_LOAD_ORDERS_EVENT_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  facilities: function facilities() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_38" /* CORE_LOAD_ALLFACILITIES_REQUEST */]:
        return [];
      case types["_39" /* CORE_LOAD_ALLFACILITIES_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  foodAndBev: function foodAndBev() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_41" /* CORE_LOAD_ALLFOODANDBEV_REQUEST */]:
        return [];
      case types["_42" /* CORE_LOAD_ALLFOODANDBEV_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  orderFacilities: function orderFacilities() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_101" /* CORE_LOAD_ORDERAMENITIES_REQUEST */]:
        return state;
      case types["_102" /* CORE_LOAD_ORDERAMENITIES_SUCCESS */]:
        if (action.payload) return action.payload;else return order_reducer_initialState;
      default:
        return state;
    }
  },
  orderFoodAndBev: function orderFoodAndBev() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_104" /* CORE_LOAD_ORDERFOODANDBEV_REQUEST */]:
        return state;
      case types["_105" /* CORE_LOAD_ORDERFOODANDBEV_SUCCESS */]:
        if (action.payload) return action.payload;else return order_reducer_initialState;
      default:
        return state;
    }
  },
  orderInfo: function orderInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_107" /* CORE_LOAD_ORDERINFO_REQUEST */]:
        return {};
      case types["_108" /* CORE_LOAD_ORDERINFO_SUCCESS */]:
        if (action.payload) return action.payload;else return order_reducer_initialState;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/events/reducer.js
// import moment from 'moment'


var events_reducer_initialState = [];
var requestState = 'request';
/* harmony default export */ var events_reducer = ({
  eventList: function eventList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : events_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_195" /* O365_LOAD_EVENTLIST_REQUEST */]:
      case types["_192" /* O365_LOAD_EVENTLIST_BETWEEN_REQUEST */]:
        return requestState;
      case types["_196" /* O365_LOAD_EVENTLIST_SUCCESS */]:
        var setEvents = [];
        if (action && action.payload && Array.isArray(action.payload.value)) {
          return action.payload.value;
        }
        return setEvents;
      case types["_193" /* O365_LOAD_EVENTLIST_BETWEEN_SUCCESS */]:
        if (action.payload) {
          return action.payload.value;
        }
        return [];
      default:
        return state;
    }
  },
  eventDetail: function eventDetail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_186" /* O365_LOAD_EVENTDETAIL_REQUEST */]:
        return {};
      case types["_187" /* O365_LOAD_EVENTDETAIL_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  setting: function setting() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_119" /* CORE_LOAD_SETTING_INFO_REQUEST */]:
        return state;
      case types["_120" /* CORE_LOAD_SETTING_INFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  eventHome: function eventHome() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_65" /* CORE_LOAD_EVENTHOME_REQUEST */]:
        return state;
      case types["_66" /* CORE_LOAD_EVENTHOME_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  eventFullCalendar: function eventFullCalendar() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_189" /* O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST */]:
        return state;
      case types["_190" /* O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS */]:
        if (action.payload) if (Array.isArray(action.payload.value)) {
          var value = [];
          action.payload.value.forEach(function (element) {
            value.push({
              title: element.subject,
              start: element.startDateTime,
              end: element.endDateTime,
              color: '#2185d0',
              event: element
            });
          });
          return value;
        }
        return [];
      default:
        return state;
    }
  }
  // rooms: (state = initialState, action) => {
  //   switch (action.type) {
  //     // case CORE_SEARCH_ROOM_REQUEST:
  //     //   return initialState
  //     // case CORE_SEARCH_ROOM_SUCCESS:
  //     //   if (action.payload)
  //     //     return action.payload
  //     //   else return []
  //     default:
  //       return state
  //   }
  // }
});
// CONCATENATED MODULE: ./src/features/informations/reducer.js


var informations_reducer_initialState = [];

/* harmony default export */ var informations_reducer = ({
    contact: function contact() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : informations_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_62" /* CORE_LOAD_CONTACT_REQUEST */]:
                return {};
            case types["_63" /* CORE_LOAD_CONTACT_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    faq: function faq() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : informations_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_80" /* CORE_LOAD_FAQ_REQUEST */]:
                return {};
            case types["_81" /* CORE_LOAD_FAQ_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    term: function term() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_125" /* CORE_LOAD_TERM_REQUEST */]:
                return {};
            case types["_126" /* CORE_LOAD_TERM_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    timezone: function timezone() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_128" /* CORE_LOAD_TIMEZOZE_REQUEST */]:
                return {};
            case types["_129" /* CORE_LOAD_TIMEZOZE_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/rooms/reducer.js

var reducer_requestState = 'request';
var rooms_reducer_initialState = [];
var initialStateObj = {};
/* harmony default export */ var rooms_reducer = ({
    rooms: function rooms() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_140" /* CORE_SEARCH_ROOM_REQUEST */]:
            case types["_116" /* CORE_LOAD_ROOMS_REQUEST */]:
                return reducer_requestState;
            case types["_141" /* CORE_SEARCH_ROOM_SUCCESS */]:
            case types["_117" /* CORE_LOAD_ROOMS_SUCCESS */]:
                if (action.payload) return action.payload;else return [];
            default:
                return state;
        }
    },
    roomsSuggest: function roomsSuggest() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateObj;
        var action = arguments[1];

        switch (action.type) {
            case types["_216" /* O365_SUGGEST_ROOM_REQUEST */]:
                return initialStateObj;
            case types["_214" /* O365_SUGGEST_ROOM_MEETING_REQUEST */]:
                return reducer_requestState;
            case types["_217" /* O365_SUGGEST_ROOM_SUCCESS */]:
            case types["_215" /* O365_SUGGEST_ROOM_MEETING_SUCCESS */]:
                if (action.payload) {
                    var payload = action.payload,
                        value = payload.result[0].roomResults;
                    if (value && value.length > 0) return value;else return [];
                } else return [];
            default:
                return state;
        }
    },
    roomsSuggesttion: function roomsSuggesttion() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateObj;
        var action = arguments[1];

        switch (action.type) {
            case types["_210" /* O365_SUGGESTTION_REQUEST */]:
                return reducer_requestState;
            case types["_211" /* O365_SUGGESTTION_SUCCESS */]:
                if (action && action.payload && Object.keys(action.payload).length > 0) return action.payload;else return {};
            case types["_209" /* O365_SUGGESTTION_FAILURE */]:
                return initialStateObj;
            default:
                return state;
        }
    },
    roomsFavor: function roomsFavor() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_9" /* CORE_GET_FAVORITEROOM_REQUEST */]:
                return reducer_requestState;
            case types["_10" /* CORE_GET_FAVORITEROOM_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    room: function room() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_21" /* CORE_GET_ROOM_INFO_REQUEST */]:
                return {};
            case types["_22" /* CORE_GET_ROOM_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    roomStatus: function roomStatus() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_24" /* CORE_GET_ROOM_STATUS_REQUEST */]:
                return {};
            case types["_25" /* CORE_GET_ROOM_STATUS_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    suggestInformation: function suggestInformation() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateObj;
        var action = arguments[1];

        switch (action.type) {
            case types["_122" /* CORE_LOAD_SUGGEST_INFORMATION_REQUEST */]:
                return initialStateObj;
            case types["_123" /* CORE_LOAD_SUGGEST_INFORMATION_SUCCESS */]:
                if (action.payload) return action.payload;else return {};
            default:
                return state;
        }
    },
    canBooking: function canBooking() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            case types["_3" /* CORE_GET_CAN_BOOKING_REQUEST */]:
                return false;
            case types["_4" /* CORE_GET_CAN_BOOKING_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/amenityandservice/reducer.js


var amenityandservice_reducer_initialState = [];
/* harmony default export */ var amenityandservice_reducer = ({
  amenityActive: function amenityActive() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_53" /* CORE_LOAD_AMENITYACTIVE_REQUEST */]:
      case types["_143" /* CORE_SENDAMENITY_REQUEST */]:
      case types["R" /* CORE_DONEAMENITY_REQUEST */]:
      case types["h" /* CORE_CANCELEVENTAMENITY_REQUEST */]:
        return {};
      case types["_54" /* CORE_LOAD_AMENITYACTIVE_SUCCESS */]:
      case types["_144" /* CORE_SENDAMENITY_SUCCESS */]:
      case types["i" /* CORE_CANCELEVENTAMENITY_SUCCESS */]:
      case types["S" /* CORE_DONEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  amenityPast: function amenityPast() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_59" /* CORE_LOAD_AMENITYPAST_REQUEST */]:
      case types["_143" /* CORE_SENDAMENITY_REQUEST */]:
      case types["R" /* CORE_DONEAMENITY_REQUEST */]:
      case types["h" /* CORE_CANCELEVENTAMENITY_REQUEST */]:
        return {};
      case types["_60" /* CORE_LOAD_AMENITYPAST_SUCCESS */]:
      case types["_144" /* CORE_SENDAMENITY_SUCCESS */]:
      case types["i" /* CORE_CANCELEVENTAMENITY_SUCCESS */]:
      case types["S" /* CORE_DONEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  amenityNext: function amenityNext() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_56" /* CORE_LOAD_AMENITYNEXT_REQUEST */]:
      case types["_143" /* CORE_SENDAMENITY_REQUEST */]:
      case types["R" /* CORE_DONEAMENITY_REQUEST */]:
      case types["h" /* CORE_CANCELEVENTAMENITY_REQUEST */]:
        return {};
      case types["_57" /* CORE_LOAD_AMENITYNEXT_SUCCESS */]:
      case types["_144" /* CORE_SENDAMENITY_SUCCESS */]:
      case types["i" /* CORE_CANCELEVENTAMENITY_SUCCESS */]:
      case types["S" /* CORE_DONEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  foodActive: function foodActive() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_86" /* CORE_LOAD_FOODACTIVE_REQUEST */]:
      case types["_146" /* CORE_SENDFOOD_REQUEST */]:
      case types["U" /* CORE_DONEFOOD_REQUEST */]:
      case types["k" /* CORE_CANCELEVENTFOOD_REQUEST */]:
        return state;
      case types["_87" /* CORE_LOAD_FOODACTIVE_SUCCESS */]:
      case types["_147" /* CORE_SENDFOOD_SUCCESS */]:
      case types["V" /* CORE_DONEFOOD_SUCCESS */]:
      case types["l" /* CORE_CANCELEVENTFOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  foodPast: function foodPast() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_92" /* CORE_LOAD_FOODPAST_REQUEST */]:
      case types["_146" /* CORE_SENDFOOD_REQUEST */]:
      case types["U" /* CORE_DONEFOOD_REQUEST */]:
      case types["k" /* CORE_CANCELEVENTFOOD_REQUEST */]:
        return state;
      case types["_93" /* CORE_LOAD_FOODPAST_SUCCESS */]:
      case types["_147" /* CORE_SENDFOOD_SUCCESS */]:
      case types["V" /* CORE_DONEFOOD_SUCCESS */]:
      case types["l" /* CORE_CANCELEVENTFOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  foodNext: function foodNext() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_89" /* CORE_LOAD_FOODNEXT_REQUEST */]:
      case types["_146" /* CORE_SENDFOOD_REQUEST */]:
      case types["U" /* CORE_DONEFOOD_REQUEST */]:
      case types["k" /* CORE_CANCELEVENTFOOD_REQUEST */]:
        return state;
      case types["_90" /* CORE_LOAD_FOODNEXT_SUCCESS */]:
      case types["_147" /* CORE_SENDFOOD_SUCCESS */]:
      case types["V" /* CORE_DONEFOOD_SUCCESS */]:
      case types["l" /* CORE_CANCELEVENTFOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderInfoService: function orderInfoService() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_68" /* CORE_LOAD_EVENTINFOSERVICE_REQUEST */]:
        return {};
      case types["_69" /* CORE_LOAD_EVENTINFOSERVICE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderAmenityList: function orderAmenityList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_71" /* CORE_LOAD_EVENTSERVICEAMENITY_REQUEST */]:
        return [];
      case types["_72" /* CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderFbsList: function orderFbsList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_74" /* CORE_LOAD_EVENTSERVICEFBS_REQUEST */]:
        return [];
      case types["_75" /* CORE_LOAD_EVENTSERVICEFBS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/hotdesk/reducer.js

var hotdesk_reducer_requestState = 'request',
    hotdesk_reducer_initialState = [];
// , initialStateObj = {}
/* harmony default export */ var hotdesk_reducer = ({
  seatFavorite: function seatFavorite() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotdesk_reducer_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_12" /* CORE_GET_FAVORITESEAT_REQUEST */]:
        return hotdesk_reducer_requestState;
      case types["_13" /* CORE_GET_FAVORITESEAT_SUCCESS */]:
        var result = [];
        if (result && Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case types["_11" /* CORE_GET_FAVORITESEAT_FAILURE */]:
        return hotdesk_reducer_initialState;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerBuilding.js

var reducerBuilding_requestState = 'request',
    reducerBuilding_initialState = [];
// , initialStateObj = {}
/* harmony default export */ var reducerBuilding = ({
  buildings: function buildings() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerBuilding_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_44" /* CORE_LOAD_ALL_BUILDING_REQUEST */]:
        return reducerBuilding_requestState;
      case types["_45" /* CORE_LOAD_ALL_BUILDING_SUCCESS */]:
        var result = [];
        if (result && Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case types["_43" /* CORE_LOAD_ALL_BUILDING_FAILURE */]:
        return reducerBuilding_initialState;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerFloor.js

var reducerFloor_requestState = 'request',
    reducerFloor_initialState = [];
// , initialStateObj = {}
/* harmony default export */ var reducerFloor = ({
  allfloor: function allfloor() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerFloor_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_47" /* CORE_LOAD_ALL_FLOOR_REQUEST */]:
        return reducerFloor_requestState;
      case types["_48" /* CORE_LOAD_ALL_FLOOR_SUCCESS */]:
        var result = [];
        if (result && Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case types["_46" /* CORE_LOAD_ALL_FLOOR_FAILURE */]:
        return reducerFloor_initialState;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerZone.js

var reducerZone_requestState = 'request',
    reducerZone_initialState = [];
// , initialStateObj = {}
/* harmony default export */ var reducerZone = ({
  allzone: function allzone() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerZone_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_50" /* CORE_LOAD_ALL_ZONE_REQUEST */]:
        return reducerZone_requestState;
      case types["_51" /* CORE_LOAD_ALL_ZONE_SUCCESS */]:
        var result = [];
        if (result && Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case types["_49" /* CORE_LOAD_ALL_ZONE_FAILURE */]:
        return reducerZone_initialState;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerSetting.js

var reducerSetting_requestState = 'request',
    reducerSetting_initialStateObj = {};
// , initialState = []

/* harmony default export */ var reducerSetting = ({
  suggestInformation: function suggestInformation() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerSetting_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_122" /* CORE_LOAD_SUGGEST_INFORMATION_REQUEST */]:
        return reducerSetting_requestState;
      case types["_123" /* CORE_LOAD_SUGGEST_INFORMATION_SUCCESS */]:
        var result = {};
        if (result && Object.keys(action.payload).length > 0) {
          result = action.payload;
        }
        return result;
      case types["_121" /* CORE_LOAD_SUGGEST_INFORMATION_FAILURE */]:
        return reducerSetting_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerSeat.js

var reducerSeat_requestState = 'request',
    reducerSeat_initialState = [],
    reducerSeat_initialStateObj = {};
/* harmony default export */ var reducerSeat = ({
  seatsuggest: function seatsuggest() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerSeat_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_149" /* CORE_SUGGEST_SEAT_REQUEST */]:
        return reducerSeat_requestState;
      case types["_150" /* CORE_SUGGEST_SEAT_SUCCESS */]:
        var result = [];
        if (result && Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case types["_148" /* CORE_SUGGEST_SEAT_FAILURE */]:
        return reducerSeat_initialState;
      default:
        return state;
    }
  },
  myeventseat: function myeventseat() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerSeat_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_15" /* CORE_GET_MYEVENT_SEATBYDATE_REQUEST */]:
        return reducerSeat_requestState;
      case types["_16" /* CORE_GET_MYEVENT_SEATBYDATE_SUCCESS */]:
        var result = [];
        if (result && Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case types["_14" /* CORE_GET_MYEVENT_SEATBYDATE_FAILURE */]:
        return reducerSeat_initialState;
      default:
        return state;
    }
  },
  eventSeatGroup: function eventSeatGroup() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerSeat_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["_6" /* CORE_GET_EVENT_SEATGROUP_REQUEST */]:
        return reducerSeat_requestState;
      case types["_7" /* CORE_GET_EVENT_SEATGROUP_SUCCESS */]:
        var result = {};
        if (result && Object.keys(action.payload).length > 0) {
          result = action.payload;
        }
        return result;
      case types["_5" /* CORE_GET_EVENT_SEATGROUP_FAILURE */]:
        return reducerSeat_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers/reducerDelete.js

var reducerDelete_requestState = 'request',
    reducerDelete_initialStateObj = {};

/* harmony default export */ var reducerDelete = ({
  eventSeatDelete: function eventSeatDelete() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDelete_requestState;
    var action = arguments[1];

    switch (action.type) {
      case types["I" /* CORE_DELETE_EVENT_SEAT_REQUEST */]:
        return reducerDelete_requestState;
      case types["J" /* CORE_DELETE_EVENT_SEAT_SUCCESS */]:
        var result = {};
        if (Object.keys(action.payload).length > 0) {
          result = action.payload;
        }
        return result;
      case types["H" /* CORE_DELETE_EVENT_SEAT_FAILURE */]:
        return reducerDelete_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers.js




















/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["b" /* reducer */],
    notifications: Object(reapop_lib["reducer"])(),
    auth: reducer.authen,
    forgotPassword: reducer.forgotPassword,
    resetPassword: reducer.resetPassword,
    user: user_reducer.user,
    users: user_reducer.users,
    integration: user_reducer.integration,
    ui: ui_reducer,
    events: events_reducer,
    orders: fb_reducer.orders,
    ordersRoom: order_reducer.ordersRoom,
    roomsFavor: rooms_reducer.roomsFavor,
    faq: informations_reducer.faq,
    contact: informations_reducer.contact,
    term: informations_reducer.term,
    rooms: rooms_reducer.rooms,
    o365Url: user_reducer.o365Url,
    eventHome: events_reducer.eventHome,
    eventList: events_reducer.eventList,
    eventDetail: events_reducer.eventDetail,
    room: rooms_reducer.room,
    roomStatus: rooms_reducer.roomStatus,
    roomsSuggest: rooms_reducer.roomsSuggest,
    roomsSuggesttion: rooms_reducer.roomsSuggesttion,
    foodActive: amenityandservice_reducer.foodActive,
    foodPast: amenityandservice_reducer.foodPast,
    foodNext: amenityandservice_reducer.foodNext,
    orderFbsList: amenityandservice_reducer.orderFbsList,
    orderInfoService: amenityandservice_reducer.orderInfoService,
    setting: events_reducer.setting,
    eventFullCalendar: events_reducer.eventFullCalendar,
    timezone: informations_reducer.timezone,
    urlGoogle: user_reducer.urlGoogle,
    seatFavorite: hotdesk_reducer.seatFavorite,
    buildings: reducerBuilding.buildings,
    allfloor: reducerFloor.allfloor,
    allzone: reducerZone.allzone,
    suggestInformation: reducerSetting.suggestInformation,
    seatsuggest: reducerSeat.seatsuggest,
    eventSeatGroup: reducerSeat.eventSeatGroup,
    myeventseat: reducerSeat.myeventseat,
    eventSeatDelete: reducerDelete.eventSeatDelete,
    facilities: order_reducer.facilities,
    foodAndBev: order_reducer.foodAndBev,
    orderFacilities: order_reducer.orderFacilities,
    orderFoodAndBev: order_reducer.orderFoodAndBev,
    orderInfo: order_reducer.orderInfo,
    canBooking: rooms_reducer.canBooking
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], lib_default.a];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(708);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(396)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/sass-loader/lib/loader.js??ref--2-3!./modalErrorMessageDialog.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/sass-loader/lib/loader.js??ref--2-3!./modalErrorMessageDialog.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(395)(true);
// imports


// module
exports.push([module.i, "html body{height:100vh;overflow:hidden;position:relative;top:0;left:0}html body>.ui.dimmer .btnEventDetail{width:50px;height:50px;text-align:center;border-radius:50%;padding-top:10px;color:#fff;border:none;display:inline-block;margin:10px;cursor:pointer}html body>.ui.dimmer .btnEventDetail>.icon{margin:0!important}html body>.ui.dimmer .btnEventDetail>p{margin-top:5px!important;color:#fff}html body .deleteBtn{background-color:red}html body .backBtn{background-color:#5adbf4}html body div>div>div>div>div>div>div>div>div>div>span{font-size:20px!important}html body div>div>div>div>div>div>div>div>div>div>div>div>div>button{font-size:16px!important}.datepicker.default{padding-bottom:50px}.hasImageBackground{width:auto;background-position:50%;background-size:cover;background-repeat:no-repeat;border-radius:10px;width:100%;height:100%;min-height:15vh}.hasImageVC{width:100%;height:100%;position:relative}.hasImageVC-background,.hasImageVC>div{width:25px;height:20px;display:inline-block;right:0;top:0;position:absolute}.hasImageVC-roomevent{position:absolute;top:0;right:15px;width:15px;height:10px}.hasImageVC-roomInfo{width:25px;height:20px;display:inline-block;right:15px;top:0;position:absolute}.hasImageVC-background,.hasImageVC-roomevent,.hasImageVC-roomInfo,.hasImageVC>div{background-image:url(\"/assets/images/vc.png\");background-position:50%;background-size:cover;background-repeat:no-repeat;border-radius:5px;padding:5px;margin:5px;z-index:2}.text-roomdisable{text-align:center}.text-roomdisable>p{color:red}.position-ab{display:inline-block;position:absolute;top:3px;right:14px}.errormessage{position:relative}.errormessage .contenterror{padding:3rem}.errormessage .contenterror .content-image{text-align:center}.errormessage .contenterror .content-image img{display:inline-block}.errormessage .contenterror .content-text{text-align:center}.errormessage .contenterror .content-text p{font-size:26px}.errormessage .close{position:absolute;cursor:pointer;top:0;right:0;padding:5px}.errormessage .close img{display:inline-block;width:25px;height:25px}", "", {"version":3,"sources":["D:/Roomminister/Roomminister_Front/src/scss/D:/Roomminister/Roomminister_Front/src/scss/D:/Roomminister/Roomminister_Front/src/scss/_config.scss","D:/Roomminister/Roomminister_Front/src/scss/D:/Roomminister/Roomminister_Front/src/scss/D:/Roomminister/Roomminister_Front/src/scss/modalErrorMessageDialog.scss"],"names":[],"mappings":"AA6FA,UACE,aACA,gBACA,kBACA,MACA,MAAO,CALT,qCAOI,WACA,YACA,kBACA,kBACA,iBACA,WACA,YACA,qBACA,YACA,cAAe,CAhBnB,2CAkBM,kBAAoB,CAlB1B,uCAqBM,yBACA,UAAW,CAtBjB,qBA0BI,oBAnGmB,CAyEvB,mBA6BI,wBAlGyB,CAqE7B,uDAiCM,wBAA0B,CAjChC,qEAoCM,wBAA0B,CAC3B,oBAIH,mBAAoB,CACrB,oBAGC,WACA,wBACA,sBACA,4BACA,mBACA,WACA,YACA,eAAgB,CACjB,YAGC,WACA,YACA,iBAAkB,CACnB,uCAIC,WACA,YACA,qBACA,QACA,MACA,iBAAkB,CACnB,sBAGC,kBACA,MACA,WACA,WACA,WAAY,CACb,qBAEC,WACA,YACA,qBACA,WACA,MACA,iBAAkB,CACnB,kFAMC,8CACA,wBACA,sBACA,4BACA,kBACA,YACA,WACA,SAAU,CACX,kBAGC,iBAAkB,CADpB,oBAGI,SAAU,CACX,aAID,qBACA,kBACA,QACA,UAAW,CCvMb,cACE,iBAAkB,CADpB,4BAGI,YAAa,CAHjB,2CAKM,iBAAkB,CALxB,+CAOQ,oBAAqB,CAP7B,0CAWM,iBAAkB,CAXxB,4CAaQ,cAAe,CAbvB,qBAkBI,kBACA,eACA,MACA,QACA,WAAY,CAtBhB,yBAwBM,qBACA,WACA,WAAY,CACb","file":"modalErrorMessageDialog.scss","sourcesContent":["// Common Style\r\n\r\n$headerBgColor: #fff; //2185d0\r\n$headerTextColor: #888888;\r\n$headerBackColor: #2185d0;\r\n$userInfoBackground: #eaeaea;\r\n\r\n$sidebarBgColor: #ebebeb;\r\n\r\n$footerBgColor: #fff;\r\n\r\n$submitButtonColor: #2185d0;\r\n\r\n$textHeaderColor: #2185d0;\r\n$textDescription: #888888;\r\n\r\n$iconColor: #2185d0;\r\n$iconOnBgColor: #fff;\r\n$iconBgColor: #2185d0;\r\n$iconBorderColor: #08ad40;\r\n$deleteIconBgColor: red;\r\n$editIconBg: #888888;\r\n$acceptIconBgColor: #08ad40;\r\n$tentativeIconBgColor: #964090;\r\n$changrPasswordColor: #5adbf4;\r\n\r\n$statusSelectColor: #8dd16a;\r\n$statusBgSelectColor: #8dd16a1a;\r\n$statusFreeColor: #2185d0;\r\n$statusBgFreeColor: #2185d01a;\r\n$statusBusyColor: #ff1a1a;\r\n$statusBgBusyColor: #ff1a1a1a;\r\n$statusDisableColor: #626262;\r\n$statusBgDisableColor: #6262621a;\r\n\r\n$headerBarHeight: 100px;\r\n$headerBarDesktopHeight: 60px;\r\n$headerBarDesktopSearchRoomHeight: $headerBarDesktopHeight + 10px;\r\n$headerImageMeetingRooms: 130px;\r\n$headerBarArrowHeight: 55px;\r\n$footerBarHeight: 50px;\r\n\r\n$wordInImage: #fff;\r\n$wordInEventItem: #fff;\r\n$selectEventItem: #52b5ee;\r\n$selectOrderfood: #94d6fb;\r\n$unselectEventItem: #94d6fb;\r\n$timeBlock: #fa2750;\r\n$labelSelectTime: cornflowerblue;\r\n$fontSizeHeaderModal: 2.5rem;\r\n$fontSizeBody: 1rem;\r\n\r\n// Mobile Style\r\n\r\n$logoWidth: 100px;\r\n$logoMaxHeight: 100px;\r\n\r\n$logo2Width: 60%;\r\n$logo2MaxHeight: 50px;\r\n\r\n// Desktop Style\r\n$desktopSize: 600px;\r\n\r\n//Size\r\n$desktopHigherSize: 1281px;\r\n$maxDesktopSize: 1280px;\r\n$minDesktopSize: 1025px;\r\n$maxTabletSize: 1024px;\r\n$minTabletSize: 768px;\r\n$maxMobileLandscapeSize: 767px;\r\n$minMobileLandscapeSize: 481px;\r\n$maxMobileSize: 480px;\r\n$minMobileSize: 320px;\r\n\r\n$dLogo2Width: 30%;\r\n$dLogo2MaxHeight: 50px;\r\n\r\n//Size text\r\n$fontSizeMassive: 32px;\r\n$fontSizeHuge: 30px;\r\n$fontSizeBig: 26px;\r\n$fontSizeLarge: 24px;\r\n$fontSizeLargeMini: 22px;\r\n$fontSizeLargeSmall: 20px;\r\n$fontSizeMedium: 18px;\r\n$fontSizeSmall: 16px;\r\n$fontSizeTiny: 14px;\r\n\r\n//Icon size\r\n$iconNextWidth: 50px;\r\n$iconNextHeight: 50px;\r\n\r\n// Common Style\r\nhtml body {\r\n  height: 100vh;\r\n  overflow: hidden;\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n  > .ui.dimmer .btnEventDetail {\r\n    width: 50px;\r\n    height: 50px;\r\n    text-align: center;\r\n    border-radius: 50%;\r\n    padding-top: 10px;\r\n    color: $iconOnBgColor;\r\n    border: none;\r\n    display: inline-block;\r\n    margin: 10px;\r\n    cursor: pointer;\r\n    > .icon {\r\n      margin: 0 !important;\r\n    }\r\n    > p {\r\n      margin-top: 5px !important;\r\n      color: #fff;\r\n    }\r\n  }\r\n  .deleteBtn {\r\n    background-color: $deleteIconBgColor;\r\n  }\r\n  .backBtn {\r\n    background-color: $changrPasswordColor;\r\n  }\r\n  div > div > div > div > div > div > div > div > div > div {\r\n    > span {\r\n      font-size: 20px !important;\r\n    }\r\n    > div > div > div > button {\r\n      font-size: 16px !important;\r\n    }\r\n  }\r\n}\r\n.datepicker.default {\r\n  padding-bottom: 50px;\r\n}\r\n\r\n.hasImageBackground {\r\n  width: auto;\r\n  background-position: center;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  border-radius: 10px;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: 15vh;\r\n}\r\n\r\n.hasImageVC {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n}\r\n\r\n.hasImageVC-background,\r\n.hasImageVC > div {\r\n  width: 25px;\r\n  height: 20px;\r\n  display: inline-block;\r\n  right: 0;\r\n  top: 0;\r\n  position: absolute;\r\n}\r\n\r\n.hasImageVC-roomevent {\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 15px;\r\n  width: 15px;\r\n  height: 10px;\r\n}\r\n.hasImageVC-roomInfo {\r\n  width: 25px;\r\n  height: 20px;\r\n  display: inline-block;\r\n  right: 15px;\r\n  top: 0;\r\n  position: absolute;\r\n}\r\n\r\n.hasImageVC-background,\r\n.hasImageVC-roomevent,\r\n.hasImageVC > div,\r\n.hasImageVC-roomInfo {\r\n  background-image: url(\"/assets/images/vc.png\");\r\n  background-position: center;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  border-radius: 5px;\r\n  padding: 5px;\r\n  margin: 5px;\r\n  z-index: 2;\r\n}\r\n\r\n.text-roomdisable {\r\n  text-align: center;\r\n  > p {\r\n    color: red;\r\n  }\r\n}\r\n\r\n.position-ab {\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 3px;\r\n  right: 14px;\r\n}\r\n","@import \"config\";\r\n\r\n.ui.modal {\r\n  .content {\r\n  }\r\n}\r\n.errormessage {\r\n  position: relative;\r\n  .contenterror {\r\n    padding: 3rem;\r\n    .content-image {\r\n      text-align: center;\r\n      img {\r\n        display: inline-block;\r\n      }\r\n    }\r\n    .content-text {\r\n      text-align: center;\r\n      p {\r\n        font-size: 26px;\r\n      }\r\n    }\r\n  }\r\n  .close {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    right: 0;\r\n    padding: 5px;\r\n    img {\r\n      display: inline-block;\r\n      width: 25px;\r\n      height: 25px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/lib/api.js
// export const CORE_API_ENDPOINT = 'https://www.bainisysstg.com/core'
// export const O365_API_ENDPOINT = 'https://www.bainisysstg.com/o365'

// export const CORE_API_ENDPOINT = 'http://localhost:2000/core'
// export const O365_API_ENDPOINT = 'http://localhost:3000/o365'

// export const CORE_API_ENDPOINT = '/roomminister/core'
// export const O365_API_ENDPOINT = '/roomminister/o365'

// export const CORE_API_ENDPOINT = 'http://10.0.10.22:2000/core'
// export const O365_API_ENDPOINT = 'http://10.0.10.22:3000/o365'

var CORE_API_ENDPOINT = '/core';
var O365_API_ENDPOINT = '/o365';

// export const CORE_API_ENDPOINT = 'https://frontend.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://frontend.rmbainisys.com/o365'

// export const CORE_API_ENDPOINT = 'https://kbankfront.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://kbankfront.rmbainisys.com/o365'
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(451);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/lib/auth.js



var BSRS_ACCESS_TOKEN = 'bsrs_access_token';
var ACCESS_TOKEN = 'access_token';
var SERVICE_TOKEN = 'service_token';
var O365_TOKEN = 'o365_token';
var EXPIRES_ON = 'expires_on';
var REFRESH_TOKEN = 'refresh_token';
var SERVICE_TOKEN_EXPIRES = 'service_token_expires_on';
var IS_INTEGRATION = 'isIntegration';
var USER_ID = 'id';
var O365_EXPIRES_ON = 'o365_expires_on';
var USER_EMAIL = 'email';
var TOKEN_EXPIRE = 'token_expire';
var IS_USER_AD = 'isUserActiveDirectory';
var TIME_ZONE = 'timeZone';
var SERVICE = 'service';
var FIRSTNAME = 'firstName';
var LASTNAME = 'lastName';
var IS_REMEMBER = 'isRemember';

function getCookie(key) {
    return js_cookie_default.a.get(key);
}

function setCookie(key, value, expires) {
    if (expires) {
        js_cookie_default.a.set(key, value, { expires: expires });
    } else {
        js_cookie_default.a.set(key, value);
    }
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function getIsUserActiveDirectory() {
    return getCookie(IS_USER_AD);
}

function getAccessToken() {
    return getCookie(SERVICE_TOKEN);
}

function getO365Token() {
    return getCookie(O365_TOKEN);
}

function getIsIntegration() {
    return getCookie(IS_INTEGRATION);
}

function getServiceType() {
    return getCookie(SERVICE);
}

function getAllToken() {
    if (!getCookie(SERVICE_TOKEN)) return {};
    return {
        access_token: getCookie(SERVICE_TOKEN),
        expires_on: getCookie(SERVICE_TOKEN_EXPIRES)
    };
}

function getIsRemember() {
    return getCookie(IS_REMEMBER);
}

function getToken() {
    if (!getCookie(SERVICE_TOKEN)) return {};
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
        user_id: getCookie(USER_ID),
        bsrsToken: getCookie(BSRS_ACCESS_TOKEN),
        isIntegration: getCookie(IS_INTEGRATION),
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN)
    };
}
function setToken(_ref) {
    var token = _ref.token,
        expires_on = _ref.expires_on;

    setCookie(SERVICE_TOKEN, token);
    setCookie(SERVICE_TOKEN_EXPIRES, expires_on);
}

function clearToken() {
    removeCookie(ACCESS_TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(REFRESH_TOKEN);
}

function getUserInfo(access_token) {
    if (!access_token) return {};

    // const {
    // //   iat,
    // //   exp,
    // //   appid,
    // //   name,
    // //   unique_name: email
    // } = jwt.decode(access_token)

    return {
        //   iat,
        //   exp,
        //   appid,
        //   name,
        //   email
    };
}

function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN);
}
function getUserEmail() {
    return getCookie(USER_EMAIL);
}
function getUserId() {
    return getCookie(USER_ID);
}

function getTimeZone() {
    return getCookie(TIME_ZONE);
}

function getUserInformation() {
    var firstName = getCookie(FIRSTNAME),
        lastName = getCookie(LASTNAME),
        email = getCookie(USER_EMAIL),
        service = getCookie(SERVICE),
        id = getCookie(USER_ID);
    return { firstName: firstName, lastName: lastName, email: email, service: service, id: id };
}

function getTokenExpire() {
    return getCookie(TOKEN_EXPIRE);
}
function setBSRSToken(bsrsToken) {
    var isRemember = bsrsToken.isRemember,
        isIntegration = bsrsToken.isIntegration,
        token = bsrsToken.token,
        id = bsrsToken.id,
        o365_token = bsrsToken.o365_token,
        o365_token_expire_on = bsrsToken.o365_token_expire_on,
        email = bsrsToken.email,
        isUserActiveDirectory = bsrsToken.isUserActiveDirectory,
        timeZone = bsrsToken.timeZone,
        firstName = bsrsToken.firstName,
        lastName = bsrsToken.lastName,
        service = bsrsToken.service,
        token_expire = bsrsToken.token_expire;

    var expires = null,
        setIsRemember = false;
    if (typeof isRemember === 'boolean' && isRemember === true) {
        setIsRemember = true;
        expires = 7;
    }
    setCookie(BSRS_ACCESS_TOKEN, token, expires);
    setCookie(IS_INTEGRATION, isIntegration, expires);
    setCookie(USER_ID, id, expires);
    setCookie(O365_TOKEN, o365_token ? o365_token : "", expires);
    setCookie(O365_EXPIRES_ON, o365_token_expire_on ? o365_token_expire_on : "", expires);
    setCookie(USER_EMAIL, email ? email : "", expires);
    setCookie(TOKEN_EXPIRE, token_expire, expires);
    setCookie(IS_USER_AD, isUserActiveDirectory, expires);
    setCookie(TIME_ZONE, timeZone, expires);
    setCookie(FIRSTNAME, firstName, expires);
    setCookie(LASTNAME, lastName, expires);
    setCookie(SERVICE, service, expires);
    setCookie(IS_REMEMBER, setIsRemember, expires);
}
function setUserInfo(_ref2) {
    var firstName = _ref2.firstName,
        lastName = _ref2.lastName;

    setCookie(FIRSTNAME, firstName);
    setCookie(LASTNAME, lastName);
}
function setRefreshToken(res) {
    if (res.value) {
        var _res$value = res.value,
            token = _res$value.token,
            expires_on = _res$value.expires_on;

        var isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false;
        var expires = null;
        if (isRemember === true) {
            expires = 7;
        }
        if (token) {
            setCookie(BSRS_ACCESS_TOKEN, token, expires);
        }
        if (expires_on) {
            setCookie(TOKEN_EXPIRE, expires_on, expires);
        }

        // let o365_token = null, o365_token_expire_on = null
        // if (user.token) {
        //     user.token.forEach(token => {
        //         const { data: { access_token, expires_on } } = token
        //         o365_token = access_token
        //         o365_token_expire_on = expires_on
        //     })
        // }
        // const { access_token, expires_on } = serviceToken
        // let token_expire = expires_on > o365_token_expire_on ? o365_token_expire_on : expires_on

        // const isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false
        // let expires = null
        //     , setIsRemember = false
        // if (isRemember === true) {
        //     expires = 7
        // }
        // setCookie(SERVICE_TOKEN, access_token, expires)
        // setCookie(BSRS_ACCESS_TOKEN, token, expires)
        // setCookie(O365_TOKEN, o365_token ? o365_token : "", expires)
        // setCookie(TOKEN_EXPIRE, token_expire, expires)
    }
}

function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN);
    removeCookie(SERVICE_TOKEN);
    removeCookie(SERVICE_TOKEN_EXPIRES);
    removeCookie(USER_ID);
    removeCookie(IS_INTEGRATION);
    removeCookie(ACCESS_TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(REFRESH_TOKEN);
    removeCookie(O365_TOKEN);
    removeCookie(O365_EXPIRES_ON);
    removeCookie(USER_EMAIL);
    removeCookie(TOKEN_EXPIRE);
    removeCookie(IS_USER_AD);
    removeCookie(TIME_ZONE);
    removeCookie(SERVICE);
    removeCookie(FIRSTNAME);
    removeCookie(LASTNAME);
}
// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var defaultDateFormat = 'MMMM DD, YYYY';
var defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm';
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 15 modules
var react_router_dom_es = __webpack_require__(69);

// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(68);

// EXTERNAL MODULE: ./src/features/auth/selectors.js
var selectors = __webpack_require__(134);

// CONCATENATED MODULE: ./src/lib/withAuthCheck.js






var withAuthCheck_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/login' });
};
var withAuthCheck_withAuthCheck = function withAuthCheck(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheck = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheck'), Object(es["connect"])(function (state) {
    return {
      isLoggedIn: Object(selectors["b" /* getIsLoggedIn */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedIn = _ref.isLoggedIn;
    return isLoggedIn;
  }, withAuthCheck_withAuthCheck, Object(Recompose["d" /* renderComponent */])(withAuthCheck_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/withAuthCheckO365.js






var withAuthCheckO365_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/logino365' });
};
var withAuthCheckO365_withAuthCheckO365 = function withAuthCheckO365(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheckO365 = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheckO365'), Object(es["connect"])(function (state) {
    return {
      isLoggedInO365: Object(selectors["c" /* getIsLoggedInO365 */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedInO365 = _ref.isLoggedInO365;
    return isLoggedInO365;
  }, withAuthCheckO365_withAuthCheckO365, Object(Recompose["d" /* renderComponent */])(withAuthCheckO365_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/withO365UserInfo.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var withO365UserInfo_withO365UserInfo = function withO365UserInfo(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, _extends({}, props, { O365UserInfo: props.userInfo }));
  };
};

/* harmony default export */ var lib_withO365UserInfo = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withO365UserInfo'), Object(es["connect"])(function (state) {
    return {
      userInfo: Object(selectors["e" /* getUserInfo */])(state)
    };
  }), withO365UserInfo_withO365UserInfo)(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return O365_API_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return getIsUserActiveDirectory; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getAccessToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getO365Token; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return getIsIntegration; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return getServiceType; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return getAllToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getIsRemember; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return getToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return setToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return clearToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return getUserInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return getBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return getUserEmail; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return getUserId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return getTimeZone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return getUserInformation; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return getTokenExpire; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return setBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return setUserInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return setRefreshToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return clearBSRSToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return timeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return defaultDateFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return defaultDateTimeFormat; });
/* unused concated harmony import withAuthCheck */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheck; });
/* unused concated harmony import withAuthCheckO365 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheckO365; });
/* unused concated harmony import withO365UserInfo */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withO365UserInfo; });







/***/ })

},[424]);


// WEBPACK FOOTER //
// app.8bb236356e62cecaac6c.js